import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import axios from 'axios';
import Select from "react-select";
import {ReactComponent as SearchIcon} from "../assets/serch-icon.svg";
import {ReactComponent as Fillheart} from '../assets/fill-heart.svg';
import { ReactComponent as TranHeart} from '../assets/tran-heart.svg';
import { ReactComponent as Plus } from "../assets/p-icon.svg";
import {ReactComponent as Dele} from '../assets/dele.svg';
import { ReactComponent as Dup} from '../assets/dup.svg';
import { ReactComponent as Edi} from "../assets/edit.svg";
import {ReactComponent as Clo_icon} from "../assets/close-icon.svg";
import {ReactComponent as Sav_icon} from "../assets/save-icon.svg";
import saveIcon from "../components/img/images/save-icon.png";
import cancelIcon from "../components/img/images/close-icon.png";
import { type } from '@testing-library/user-event/dist/type';
import './Recipes.css';
const RecipesTable = forwardRef(({ onPageNameChange,currencyDash, uId }, ref) => {
  const [recipesAll, setRecipesAll] = useState({});
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [showIcon, setShowIcon] = useState(true);
  const [isfavorite, setIsfavorite] = useState({});
  const [tabless, setTabless] = useState(true)
  const currentId = 2;
              // Add New recipe
  const [newRec, setNewRec] = useState(false);
  const [smallMedia, setSmallMedia] = useState(window.innerWidth <= 768); // Adjust breakpoint as needed
  const [arowDwn, setArowDwn] = useState(true);
  const [arowDwnGar, setArowDwnGar] = useState(true);
  const [arowDwnNw, setArowDwnNw] = useState(true);
  const [arowDwnGarNw, setArowDwnGarNw] = useState(true);

  useEffect(() => {
      const handleResize = () => {
          setSmallMedia(window.innerWidth <= 768);
      };
  
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);
    // Edit recipe js
    const [products, setProducts] = useState([]);
    const [total, setTotal] = useState(0);
    const [selectedProduct, setSelectedProduct] = useState("");
    const [productValue, setProductValue] = useState("");
    const [selectedImage, setSelectedImage] = useState("");
    const [selectedImage2, setSelectedImage2] = useState(selectedImage);
    const [showDrop, setShowDrop] = useState(false);
    const [imageName, setImageName] = useState("");
    const [selectedOption, setSelectedOption] = useState('');
    const [reName, setReName] = useState("");
    const [selectedImages, setSelectedImages] = useState([]);
    const [selectedGar, setSelectedGar] = useState([]);
    const [showImageList, setShowImageList] = useState(false);
    const [selectedPreparations, setSelectedPreparations] = useState([]);
    const [showPreparationList, setShowPreparationList] = useState(false);
    const [textArea, setTextArea] = useState("");
    const [sellingPrice,setSellingPrice] = useState("");
    const [cate,setCate] = useState("");
    const [singleImage, setSingleImage] = useState("");
    const [editR, setEditR] = useState(false);
    const [favorite, setFavorite] = useState(false);
    const [getCats, setGetCats] = useState([]);
    const [ingredients, setIngredients] = useState([]);
    const [getCost, setGetCost] = useState(0);
    const [productStep, setProductStep] = useState(0);
    const [singleCost, setSingleCost] = useState(0);
    const [grandTotal, setGrandTotal] = useState(0);
    const [getId, setGetId] = useState("");
    const [selectedPrep, setSelectedPrep] = useState("");
    const [getedCatId,setGetedCatId] = useState();
    const [garnishes, setGarnishes] = useState([]);
    const [preparationsSteps, setPreparationsSteps] = useState([]);
    const [garId , setGarId] = useState([]);
    const [prepId, setPrepId] = useState([]);
    
    // const [userId, setuserId] = useState(4);
    const [editId ,setEditId] = useState();
    const [recipeEId,setRecipeEId] = useState(); 
    const itemsPerPage = 10;
    const [dyHeight, setDyHeight] = useState(0);
    const [getJuice, setGetJuice] = useState([]);
    const [mId, setMachineId] = useState();
    const [userD, setUserD] = useState(null);
    const [recipeMainImages, setRecipeMainImages] = useState([]);
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [supAdmin, setSupAdmin] = useState(false);
    const [selIngreType, setSelIngreType] = useState("");
    const [imageUrls, setImageUrls] = useState({});
    const [recImgExtn, setRecImgExtn] = useState("");
    const [editRIName, setEditRIName] = useState("");
    const [imageChange, setImageChange] = useState(false);
    const [uName, setUName] = useState("");
    const [reqMl, setReqMl] = useState(0);
    const [snglAlco, setSnglAlco] = useState("");
    const [ttlalco, setTtlalco] = useState(0);
    const [imageSearch, setImageSearch] = useState("");
    const [pumpsData, setPumpData] = useState([]);
    useEffect(() => {
      const userDataString = sessionStorage.getItem('userData');
      const supperAdminData = sessionStorage.getItem('super');
      if (userDataString) {
          const userData = JSON.parse(userDataString);
          setUserD(userData);
          // Use userData as needed
      }
      if(supperAdminData === 'true'){
       // console.log(supperAdminData," Check it is it supper admin");
        //console.log("Supper admin is true");  
        setSupAdmin(true);   
      }
      
  }, []);
  useEffect(() => {
      setMachineId(userD ?.selectedMachineIds);
      setUName(userD?.name);
  }, [userD]);
    // if(uId != ""){
      // setuserId(uId);
      
    // }
    useEffect(() => {
      fetchRecipes();
      fetchCategories();
      fetchPumps();
      fetchIngredients();
      fetchGarnishes();
      fetchPrepSteps();
      fetchRecImages();
      renderPreparationImages();
      renderGarnishImages();  
      renderRecipeImages();
    }, [uId]);
    const handleClick = (name) => {
      onPageNameChange(name); // Call the function passed down from the parent
    };
    const fetchRecipes = async () => {
      let uUid;
      const userDataString = sessionStorage.getItem('userData');
      if (userDataString) {
          const userData = JSON.parse(userDataString);
          // setUserD(userData);
          uUid=userData?.id;
      }
      
      const mIds = mId;
      
      try {
        const url = mIds 
          ? `/api/recipesF/${uUid}?mIds=${mIds}`
          : '';

        const response = await axios.get(url, { withCredentials: true });
        setRecipesAll(response.data);
        // console.log(response.data, "This is all recipes");
        // alert("Recipes function call", response.data.leng)
      } catch (error) {
        console.error('Error fetching recipes:', error);
      }
    };
    
  const fetchCategories = async () => {
      
    try {
      const response = await axios.get('/api/categories-data', {
        withCredentials: true
      });
      setGetCats(response.data);
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };
  const fetchPumps = async () => {
    if (!uId) {
      console.error('userId is required');
      return;
    }
      const userData = JSON.parse(sessionStorage.getItem('userData'));
      if (!userData || !userData.id) {
      throw new Error('User ID not found in session storage');
      }
      const userId = userData.id;
      const macId2 = userData.selectedMachineIds;
    try {
      const response = await axios.get(`/api/pump-data?userId=${userId}&macId=${macId2 || ''}`,
        { withCredentials: true }
      );
      setPumpData(response.data);
      // console.log(response.data, "all pumps data");
      
      return response.data;
    } catch (error) {
      console.error('Error fetching pumps:', error);
    }
  };
    const fetchIngredients = async () => {
    const macId = mId;
        const userData = JSON.parse(sessionStorage.getItem('userData'));
        if (!userData || !userData.id) {
        throw new Error('User ID not found in session storage');
        }
        const userId2 = userData.id;
        const macId2 = userData.selectedMachineIds;
    try {
      const response = await axios.get(
        `/api/ingredients?userId=${userId2}&macId=${macId2 || ''}`,
        { withCredentials: true }
      );
      setIngredients(response.data);
    } catch (error) {
      console.error('Error fetching ingredients:', error);
    }
  };
    // Expose the function to parent using ref
  useImperativeHandle(ref, () => ({
    fetchPumps,
    fetchRecipes,
    fetchIngredients,
  }));
  const pumpMap = pumpsData.reduce((acc, pump) => {
  const key = `${pump.ing_id}_${pump.type.toLowerCase()}`;

  if (!acc[key]) {
    acc[key] = 0;
  }

  acc[key] += Number(pump.level_ml);

  return acc;
}, {});

const isRecipeAvailable = (recipe) => {
  const ids = recipe.ingredient_ids.split(",");
  const types = recipe.types
    .split(",")
    .map(t => t.toLowerCase());
  const quantities = recipe.quantities
    .split(",")
    .map(Number);

  return ids.every((id, index) => {
    const key = `${id}_${types[index]}`;
    const availableMl = pumpMap[key] || 0;
    const requiredMl = quantities[index];

    return availableMl >= requiredMl;
  });
};
  // Function to fetch all garnishes from Node.js server
const fetchGarnishes = async () => {
    
  try {
    const response = await axios.get('/api/garnishes', {
      withCredentials: true
    });
    setGarnishes(response.data);
    // console.log(response.data);
    
  } catch (error) {
    console.error('Error fetching garnishes:', error);
  }

};
  // Function to fetch all garnishes from Node.js server
  const fetchPrepSteps = async () => {
    
    try {
      const response = await axios.get('/api/prepsteps', {
        withCredentials: true
      });
      // return response.data; // Assuming the server returns preparations in JSON format
      setPreparationsSteps(response.data);
      // console.log(response.data);
    } catch (error) {
      console.error('Error fetching preparations:', error);
      // return []; // Return empty array if there's an error
    }
  
  };
  const handlePerPageChange = (e) => {
    setPerPage(parseInt(e.target.value));
    const heightTable = perPage * 8 + '%';
    setDyHeight(perPage * 8 + '%');
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setShowIcon(e.target.value === '');
  };

  const handleFavoriteClick = async (recipe) => {
    // console.log(`Favorite clicked for recipe ${recipe.id}`);
    // console.log(`Favorite user Id clicked for recipe ${recipe.user_id}`);
    
    try {
      const response = await axios.post(
        '/api/wishlist',
        { user_id: recipe.user_id, cocktails_id: recipe.id },
        { withCredentials: true }
      );
      fetchRecipes();
      // alert(response.data.message);
    } catch (error) {
      console.error('Error:', error);
      // Handle error
    }
  };

  const handleDuplicateClick = (recipe) => {
    // console.log(recipe);
    // alert(`Duplicate clicked for recipe ${id}`);
  };
// Add a useEffect hook to ensure the products state is updated before accessing it
useEffect(() => {
  // console.log(products); 
}, [products]); // Run this effect whenever products state changes
const fetchImage3 = async (imgname, nmbr) => {

    const res = await axios.get(
      `/api/image-base?image-name=${imgname}`,
      { responseType: 'blob', withCredentials: true }
    );
  const imageUrl = URL.createObjectURL(res.data);
  if(nmbr === 1){
    setSelectedImage2(imageUrl);
    setSelectedImage(imageUrl);
  }else{
  setSelectedImage(imageUrl);
  setSelectedImage2(imageUrl);
  }
  
};
const handleEditClick = (recipe) => {
  setSelectedPreparations([]);
  setSelectedImages([]);
  setGarId([]);
  setPrepId([]);

  // console.log(recipe, "recipe to edit");
  // console.log("recipe_id", recipe.recipe_id, "cocktail_id", recipe.id);
  
  handleClick("Edit Recipe");
  setTabless(false);
  setReName(recipe.name);
  setGetedCatId(recipe.category_id);
  setFavorite(recipe.favorite === 1);
  setTextArea(recipe.procedures);
  setSellingPrice(recipe.selling_price);
  setGrandTotal(recipe.cost);
  setEditId(recipe.id);
  setRecipeEId(recipe.recipe_id);
  setReqMl(recipe.qtty);
  const totalAlcohol =
  recipe.alcohol_ml
    .split(",")
    .reduce(
      (sum, value) =>
        sum + Number(value),
      0
    );

setTtlalco(totalAlcohol);
  if (recipe.image) {
      setEditRIName(recipe.image);
      const iNA = removeFileExtension2(recipe.image);
      setImageName(iNA.nameWithoutExt);
      fetchImage3(recipe.image, 1);
  } else {
      setSelectedImage2();
  }

  // Handling single or multiple prep_img
  if (recipe.prep_img) {
    fetchPrepSteps();
  const preparationImages =
    recipe.prep_img
      .split(',')

      .map((image, index) => {

        const imagePath =
          require(
            `../components/img/preparation/${image}`
          );
        // find matching preparation
        const matchedPreparation =

          preparationsSteps.find( prep => prep.image === image);


        return {
          imageName: imagePath,
          name: matchedPreparation ? matchedPreparation.steps : image.split('.')[0], index: index
        };

      });


  setSelectedPreparations(preparationImages);

}

  if (recipe.garnish_image) {
      fetchGarnishes();
  const garnishImages =
    recipe.garnish_image
      .split(',')

      .map((image, index) => {

        const imagePath =
          require(
            `../components/img/Garnishes/${image}`
          );


        // find matching garnish
        const matchedGarnish =

          garnishes.find( garnish => garnish.image === image);


        return {

          imageName:
            imagePath,
          name: matchedGarnish ? matchedGarnish.name : image.split('.')[0], index: index

        };

      });


  setSelectedImages(garnishImages);

}

  // Handling single or multiple garid
  if (recipe.garnish) {
      const garIds = recipe.garnish.split(',').map(id => ({ id }));
      setGarId(garIds);
  }

  // Handling single or multiple preparation id
  if (recipe.preparation) {
      const prepIds = recipe.preparation.split(',').map(id => ({ id }));
      setPrepId(prepIds);
  }
  if (
    recipe.ingredient_ids &&
    recipe.ingredient_names &&
    recipe.quantities &&
    recipe.ingredient_cost_ml &&
    recipe.types &&
    recipe.steps &&
    recipe.alcohol_ml
  ) {
  const eIdArray = recipe.ingredient_ids.includes(",")
    ? recipe.ingredient_ids.split(",")
    : [recipe.ingredient_ids];

  const eNameArray = recipe.ingredient_names.includes(",")
    ? recipe.ingredient_names.split(",")
    : [recipe.ingredient_names];
  
  const estepArray = recipe.steps.includes(",")
  ? recipe.steps.split(",")
  : [recipe.steps];

  const eQuantityArray = recipe.quantities.includes(",")
    ? recipe.quantities.split(",")
    : [recipe.quantities];

  const eCostmlSingle = recipe.ingredient_cost_ml.includes(",")
    ? recipe.ingredient_cost_ml.split(",")
    : [recipe.ingredient_cost_ml];

  const eAlcoholSingle = recipe.alcohol_ml.includes(",")
    ? recipe.alcohol_ml.split(",")
    : [recipe.alcohol_ml];

  const eTypesArray = recipe.types.includes(",")
    ? recipe.types.split(",")
    : [recipe.types];

  if (
    eIdArray.length === eNameArray.length &&
    eNameArray.length === eQuantityArray.length &&
    eQuantityArray.length === eCostmlSingle.length &&
    estepArray.length === eNameArray.length &&
    eCostmlSingle.length === eTypesArray.length &&
    eAlcoholSingle.length === eCostmlSingle.length
  ) {
    const newProducts = eIdArray.map((eId, index) => ({
      id: parseInt(eId, 10),
      name: eNameArray[index],
      proStep: parseInt(estepArray[index], 10),
      value: parseFloat(eQuantityArray[index]),
      cost_ml: parseFloat(eCostmlSingle[index]),
      type: eTypesArray[index], 
      alcohol: eAlcoholSingle[index],
      t_cost:
        parseFloat(eCostmlSingle[index]) * parseFloat(eQuantityArray[index]),
    }));
    // console.log(newProducts, "new products in eidt");
    
      setProducts((prevProducts) => [...prevProducts, ...newProducts]);
    } else {
      console.error("Lengths of ingredient arrays do not match.");
    }
  } else {
    console.error("One or more ingredient fields are missing.");
  }
  if (recipe.quantities) {
      const quantitiesArray = recipe.quantities.split(',').map(Number);
      const totalQuantity = quantitiesArray.reduce((total, quantity) => total + quantity, 0);
      setTotal(totalQuantity);
  }

  setCate(recipe.category_name);
  setEditR(true);

  // Remove the selected row from the tableData state
  //setRecipesAll(prevRecipesAll => prevRecipesAll.filter(item => item.id !== recipe.id));
};

      const totalCost = products.reduce((total, product) => {
        // Parse the value to ensure it's a number
        const value = parseFloat(product.value);
        // Calculate the cost of the current product (value * cost per ml)
        const productCost = value * getCost;
        // Add the cost of the current product to the total
        return total + productCost;
      }, 0);
useEffect(() => {
  // Calculate total based on updated products
  const newTotal = products.reduce((acc, product) => acc + product.value, 0);
  setTotal(newTotal);
}, [products]);
  // };
  const handleDeleteClick = async (recipe) => {
    // Show a confirmation dialog
    const confirmDelete = window.confirm(`Are you sure you want to delete the recipe "${recipe.name}"?`);
      
    // Check if the user confirmed the deletion
    if (confirmDelete) {
      try {
        const response = await axios.delete(
          `/api/recipes/${recipe.id}`,
          { data: { user_id: recipe.user_id }, withCredentials: true }
        );
        fetchRecipes();
  
        // alert(response.data.message);
      } catch (error) {
        console.error('Error:', error);
        // Handle error
      }
    }
  };
// Filter recipes based on searchTerm
const filteredRecipes = Array.isArray(recipesAll)
  ? recipesAll.filter((recipe) =>
      recipe.name
        ?.toLowerCase()
        .includes(searchTerm.toLowerCase())
    )
  : [];
const uniqueFilteredRecipes = filterDuplicates(filteredRecipes);

// Pagination logic
const indexOfLastRecipe = currentPage * perPage;
const indexOfFirstRecipe = indexOfLastRecipe - perPage;

const totalPages = Math.ceil(uniqueFilteredRecipes.length / perPage);

// const paginate = (pageNumber) => setCurrentPage(pageNumber);
const paginate = (pageNumber) => {
  setCurrentPage(pageNumber);

  requestAnimationFrame(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });
};
const currentRecipes = uniqueFilteredRecipes.slice(indexOfFirstRecipe, indexOfLastRecipe);

useEffect(() => {
  // console.log('Current Recipes:', currentRecipes);
}, [currentRecipes]);

useEffect(() => {
}, [uniqueFilteredRecipes]);
function filterDuplicates(recipes) {
  const uniqueIds = new Set();
  return recipes.filter(recipe => {
      if (uniqueIds.has(recipe.id)) {
          return false; // Skip if the ID is already in the set
      } else {
          uniqueIds.add(recipe.id);
          return true; // Include if it's a new ID
      }
  });
}
useEffect(() => {
  // console.log('Recipes All:', recipesAll);
}, [recipesAll]);


  const currentImage = (selected) =>{
    let nameOfImage = selected.name;
    fetchImage3(nameOfImage, 2);
    // console.log(selected);
    setShowDrop(false);
    // const spArray = selected.name.split(".");
    // console.log("sllited name ",spArray);
    setImageChange(true);
    const iNA = removeFileExtension2(selected.name);
      setImageName(iNA.nameWithoutExt);   // sets filename without extension
      setRecImgExtn(iNA.extension);        // sets extension      
  }
  const showContainer = () =>{
    setShowDrop(!showDrop);
  }
  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleImageClick = (garnishe) => {
    const imageNameF = garnishe.image;
    const firstSplit = imageNameF.split("/").pop();
    let p_name, p_extension, imgPthNm;
    // console.log("clciked garnishes", garnishe);
    

    if (firstSplit.includes(".")) {
        const secondSplit = firstSplit.split(".");
        imgPthNm = secondSplit[0];
        p_name = garnishe.name;
        p_extension = secondSplit.pop();
    } else {
        p_name = firstSplit;
        p_extension = ''; // or null, depending on how you want to handle it
    }

    const imageName = imgPthNm + (p_extension ? "." + p_extension : "");
    const imagePath = require(`../components/img/Garnishes/${imageNameF}`); 
    const garnishesImage = {
        imageName: imagePath,
        name: p_name
    };
    const garnisheshId = {
      id: garnishe.id
    }

    // Check if garnish is already selected
    const isGarnishSelected = selectedImages.some(selected => selected.imageName === garnishesImage.imageName);
    
    // If the garnish is already selected, do nothing
    if (isGarnishSelected) {
      setShowImageList(false);
      return;
    }

    // Check if garId already exists in the state
    if (garId.includes(garnishe.id)) {
        // If it exists, remove it from garId
        setGarId(garId.filter(id => id !== garnisheshId.id));
    } else {
        // Otherwise, add it to garId
        setGarId([...garId, garnisheshId]);
    }

    // Add the garnish to the selected images
    setSelectedImages([...selectedImages, garnishesImage]);
    setShowImageList(false);
  };

const handlePreparationClick = (preparation) => {
  // console.log(preparation.steps, "Clciked preparation");
  
  const prepImage = preparation.image;
  const firstSplit = prepImage.split("/").pop();
  let p_name, p_extension, imgPathNm;

  if (firstSplit.includes(".")) {
      const secondSplit = firstSplit.split(".");
      imgPathNm = secondSplit[0];
      p_name = preparation.steps;
      p_extension = secondSplit.pop();
  } else {
      p_name = firstSplit;
      p_extension = ''; // or null, depending on how you want to handle it
  }

  // const imageName = p_name + (p_extension ? "." + p_extension : "");
  const imageName = imgPathNm + (p_extension ? "." + p_extension : "");
  const imagePath = require(`../components/img/preparation/${imageName}`); 
  const preparationImage = {
      imageName: imagePath,
      name: p_name
  };
  const preparationsId = {
    id: preparation.id
  }

  // Check if preparation is already selected
  const isPreparationSelected = selectedPreparations.some(selected => selected.imageName === preparationImage.imageName);
  
  // If the preparation is already selected, do nothing
  if (isPreparationSelected) {
    setShowPreparationList(false);
      return;
  }

  // Check if prepId already exists in the state
  if (prepId.includes(preparation.id)) {
      // If it exists, remove it from prepId
      setPrepId(prepId.filter(id => id !== preparationsId.id));
  } else {
      // Otherwise, add it to prepId
      setPrepId([...prepId, preparationsId]);
  }

  // Add the preparation to the selected preparations
  setSelectedPreparations([...selectedPreparations, preparationImage]);
  setShowPreparationList(false)
};


const handleRemovePreparation = (selectedImageToRemove) => {
  // console.log(selectedImageToRemove.name, "Selected image to remove garnishes.");

  // Assuming garnishes is an array of objects where each object has a name and an id
  const garnishToRemove = garnishes.find(garnish => garnish.image === selectedImageToRemove.name+".png");

  if (garnishToRemove) {
    // Remove the id from garId
    setGarId(garId.filter(grId => grId.id !== String(garnishToRemove.id)));
  }
  // Remove the selected image from selectedImages
  setSelectedImages(selectedImages.filter(selectedImage => selectedImage !== selectedImageToRemove));
};
const handleRemovePrep = (selectedPreparationToRemove) => {

  // Find the preparation to remove based on the image name
  const prepToRemove = preparationsSteps.find(
    prepstep => prepstep.image === selectedPreparationToRemove.name + ".png"
  );

  if (prepToRemove) {
    setPrepId(prepId.filter(prpId => prpId.id !== String(prepToRemove.id)));
  }

  // Remove the selected preparation from selectedPreparations
  setSelectedPreparations(
    selectedPreparations.filter(
      selectedPreparation => selectedPreparation !== selectedPreparationToRemove
    )
  );
};
  const handleDeleteProduct = (index) => {
    const deletedProduct = products[index];
    // console.log(products[index], " product to delte");
    const { value: deletedValue } = deletedProduct;
    // console.log(deletedValue + " taken delete product form list");
    const deletedCost = products[index].t_cost;
    const deleteAlco = products[index].alcohol;
    const updatedAlco = +ttlalco - +deleteAlco;
    if(updatedAlco){
      setTtlalco(updatedAlco);
    }else{
      setTtlalco(0);
    }
    // console.log(deletedCost + ' this is current single cost to delete');
    const updatedTotal = grandTotal - deletedCost;
    const upperTotal = parseFloat(updatedTotal);
    setGrandTotal(updatedTotal);
    
    const updatedProducts = [...products];
    updatedProducts.splice(index, 1);
    setProducts(updatedProducts);
  
    // // Check if there are no products left
    if (updatedProducts.length === 0) {
      // Set the grand total to 0
      setGrandTotal(0);
    }
  };

  const handleRecalculate = () => {
    const newTotal = products.reduce((acc, curr) => acc + curr.value, 0);
    setTotal(newTotal);
  };
  const backTbl = () => {
    // console.log("check image name simple", imageName);
    let selectedIName;
    const newIName = `${imageName}.${recImgExtn}`;
    if(imageChange === true){
      selectedIName = newIName;
    }else{
      selectedIName = editRIName;
    }

    const invalidIndex = products.findIndex(product => 
      !product.id ||
      !product.proStep ||
      !product.value ||
      !product.type ||
      isNaN(product.proStep) ||
      isNaN(product.value)
    );

    if (invalidIndex !== -1) {
      alert(`Invalid product # ${invalidIndex + 1}`);
      return;
    }

    const dataToSend = {
        userId: uId,
        mIds: mId[0],
        // recipe_id: recipeEId,
        cocktails_id: editId,
        total: total,
        reName: reName,
        favorite: favorite, // optional
        textArea: textArea,
        sellingPrice: sellingPrice,
        cate: cate,
        getedCatId: getedCatId,
        grandTotal: grandTotal,
        selectedPreparations: selectedPreparations.map(prep => prep.name),
        selectedPreparationsImages: selectedPreparations.map(prep => prep.name + ".png"),
        selectedImages: selectedImages.map(img => img.name),
        selectedGarId: garId.map(gar => `${gar.id}`),
        selectedPrepId: prepId.map(prep => `${prep.id}`),
        selectedImagesName: selectedImages.map(img => img.name + ".png"),
        selectedIName: selectedIName,
        products: products.map(product => `${product.id} ${product.proStep} ${product.value} ${product.type}`)

      };

      // Validation before sending
      const isEmptyField = Object.entries(dataToSend).some(([key, value]) => {
        if (key === 'favorite') return false; // skip favorite
        if (Array.isArray(value)) return value.length === 0; // arrays must have at least 1 item
        return !value; // strings, numbers, undefined, null
      });
  // console.log(isEmptyField, "this is data set to send in update recipe");

  // 🔍 Deep validation before sending
const emptyFields = [];

Object.entries(dataToSend).forEach(([key, value]) => {

  if (key === "favorite") return; // skip favorite

  // 🔹 If value is array
  if (Array.isArray(value)) {

    if (value.length === 0) {
      emptyFields.push(`${key} is empty array`);
      return;
    }

    value.forEach((item, index) => {

      // Check empty primitive
      if (!item || item.toString().trim() === "") {
        emptyFields.push(`${key}[${index}] is empty`);
        return;
      }

      // 🔥 Special validation for products array
      if (key === "products") {
        const parts = item.split(" ");

        if (parts.length !== 3) {
          emptyFields.push(`${key}[${index}] has invalid format`);
          return;
        }

        const [id, val, type] = parts;

        if (!id) emptyFields.push(`${key}[${index}] missing id`);
        if (!val) emptyFields.push(`${key}[${index}] missing value`);
        if (!type) emptyFields.push(`${key}[${index}] missing type`);
      }

    });

    return;
  }

  // 🔹 Normal field
  if (!value || value.toString().trim() === "") {
    emptyFields.push(`${key} is empty`);
  }

});


      if (isEmptyField) {
        alert(
          `The following fields are required:\n\n${emptyFields.join("\n")}`
        );
        return;
      } else {
        axios.post('/api/update-recipe', dataToSend, { withCredentials: true })
          .then(response => {
            fetchRecipes();
              setEditR(false);
              setTabless(true);
              setNewRec(false);
              setTabless(true);
              setEditR(false);
              setProducts([]);
              setTextArea("");
              setSelectedPreparations([]);
              setSelectedImages([]);
              setSellingPrice("");
              setFavorite(false);
              setTtlalco(0);
              setReqMl(0);
              setCate("Choose Category");
              if(recipeMainImages.length !== 0){
                fetchImage3(recipeMainImages[0].name, 2)
              }
              
              setGrandTotal(0);
              onPageNameChange("Recipes"); 
              setProducts([]);
            // console.log(response.data);
          })
          .catch(error => {
            console.error('Error sending data to server:', error);
          });
      }
  };
  const handleClose = () => {
    setEditR(false);
    setNewRec(false);
    setTabless(true);
    setProducts([]);
    setTextArea("");
    setSelectedPreparations([]);
    setSelectedImages([]);
    setSellingPrice("");
    setSelectedPreparations([]);
    setSelectedImages([]);
    setFavorite(false);
    setReqMl(0);
    setGrandTotal(0);
    setTtlalco(0);
    handleClick("Recipes");
  }

  const handleAddProduct = () => {
    // if(reqMl === 0 || reqMl === ''){
    //   alert("Add the required Total(ml)");
    //   return;
    // }
    // console.log(selectedProduct, productValue, getId, "these are from add product");
    const splitid = getId.split('_');
    const splitedId = splitid[1];

    const isProductExists = products.some(product => product.name === selectedProduct);
    
    if (isProductExists) {
      alert(`${selectedProduct} is already added.`);
      return; 
    }
    if (selectedProduct && productValue && splitedId) {
      const newTotal = (+total / 100 * +reqMl) + +productValue;
      const snglProAlc = Number(productValue) * (+snglAlco/100);
      const snglPer = Number(productValue);

      const newProduct = {
        id: splitedId,
        name: selectedProduct,
        value: parseFloat(snglPer),
        cost_ml: getCost,
        t_cost: getCost * parseFloat(productValue),
        type: selIngreType,
        alcohol: Number(snglProAlc),
        proStep: productStep ? parseInt(productStep, 10) : 1 // ✅ condition
      };
    const currentSingleCost = getCost * productValue;

    setSingleCost(currentSingleCost);
    setTtlalco(
  prevTtlalco =>
    Number(prevTtlalco) + Number(snglProAlc)
);
    setGrandTotal(prevTotal => prevTotal + currentSingleCost); 
      setProducts([...products, newProduct]);
      setTotal(total + parseFloat(productValue));
      setSelectedProduct("");
      setProductValue("");
      setGetId();
      setSingleCost();

    }else{
      alert("Select Both Name and Quantity!");
    }
  };
  const setCostIng = (ingredient) =>{
    setGetCost(ingredient.cost_ml)
  } 
                  // new Recipe
  const toggleNew = () =>{
    setNewRec(true);
    setTabless(false);
    setEditR(false);
    setProducts([]);
    setTextArea("");
    setSelectedPreparations([]);
    setSelectedImages([]);
    setSellingPrice("");
    setFavorite(false);
    setCate("Choose Category");
    setReqMl(0);
    if(recipeMainImages.length !== 0){
      fetchImage3(recipeMainImages[0].name, 2);
    }
    
    setReName("");
    handleClick("New Cocktail");
    smallRecipesImages();
    setGarId([]);
    setPrepId([]);
  }

  const backTblNN = () => {
    // console.log(products,"All products of new recipe");
    
    const newIName = `${imageName}.${recImgExtn}`;

    const uUid = uId;
    // alert(selectedImage2+" This is image name");
    const selectedIName1st = selectedImage2.split("=").pop();
    // alert(selectedIName1st+" splited by =");
    const selectedIName = newIName;

    // Prepare the data to send to the server
    const dataToSend = {
        total: total,
        mIds:mId[0],
        reName: reName,
        favorite: favorite,
        textArea: textArea,
        sellingPrice: sellingPrice,
        cate: cate,
        getedCatId: getedCatId,
        grandTotal: grandTotal,
        selectedPreparations: selectedPreparations.map(preparation => preparation.name),
        selectedPreparationsImages: selectedPreparations.map(preparation => preparation.name + ".png"),
        selectedImages: selectedImages.map(image => image.name),
        selectedGarId: garId.map(gar => `${gar.id}`),
        selectedPrepId: prepId.map(prep => `${prep.id}`),
        selectedImagesName: selectedImages.map(image => image.name + ".png"),
        selectedIName: selectedIName,
        products: products.map(product => `${product.id} ${product.proStep} ${product.value} ${product.type}`)
    };
    // console.log(dataToSend, " data to send in new Recipe");
    
  // Check if any field in dataToSend is null, excluding the 'favorite' field
const emptyFields = [];

Object.entries(dataToSend).forEach(([key, value]) => {
  if (
    key !== "favorite" &&
    (value === null ||
      value === undefined ||
      value.toString().trim() === "")
  ) {
    emptyFields.push(
      key
        .replace(/([A-Z])/g, " $1")
        .replace(/^./, str => str.toUpperCase())
    );
  }
});

if (emptyFields.length > 0) {
  alert(
    `The following fields are required:\n\n${emptyFields.join("\n")}`
  );
  return;
}
    // Send the data to the server
          axios.post(
            `/api/new-recipe/${uUid}`,
            dataToSend,
            { withCredentials: true }
          )
        .then(response => {
            fetchRecipes();
            alert(response.data); // Log the response from the server
        })
        .catch(error => {
            console.error('Error sending data to server:', error);
        });

    setNewRec(false);
    setTabless(true);
    setEditR(false);
    setProducts([]);
    setTextArea("");
    setSelectedPreparations([]);
    setSelectedImages([]);
    setSellingPrice("");
    setSelectedPreparations([]);
    setSelectedImages([]);
    setFavorite(false);
    setCate("Choose Category");
    setReqMl(0);
    if(recipeMainImages.length !== 0){
      fetchImage3(recipeMainImages[0].name, 2);
    }
    
    setGrandTotal(0);
}
const heightStyle = () => {
  const displayedRecipes =
  searchTerm === ""
    ? currentRecipes
    : uniqueFilteredRecipes;
  const diff = displayedRecipes.length;
  if (diff < 5) {
    // alert(diff);
    return `${diff * 11}%`;
  } else if (diff < 10) {
    return `${diff * 8}%`;
  } else {
    return '';         
  }
};
  // Function to render the list of preparation images
  const renderPreparationImages = () => {
    return preparationsSteps.map((preparationsStep, index) => (
      <div className='prep-img-cont-both' onClick={() => handlePreparationClick(preparationsStep)}>
        <img
        key={index}
        alt="PreparationIcon"
        src={require(`../components/img/preparation/${preparationsStep.image}`)}
        className={`gar-img ${smallMedia ? 'gar-img-2' : ''}`}
      />
      <div className='prep-img-name'>{preparationsStep.steps}</div>
      </div>
      
    ));
  };
    // Function to render each garnish image
    const renderGarnishImages = () => {
      return garnishes.map((garnish, index) => (
        <div className='prep-img-cont-both'
        onClick={() => handleImageClick(garnish)}
        >
        <img
          key={index}
          alt="garnishIcon"
          src={require(`../components/img/Garnishes/${garnish.image}`)}
          className={`gar-img ${smallMedia ? "gar-img-2" : ""}`}
          
        />
        <div className='prep-img-name'>{garnish.name}</div>
        </div>
      ));
    };

  useEffect(() => {
    smallRecipesImages();
  }, [recipeMainImages]);
  const smallRecipesImages = () =>{
    if (recipeMainImages && recipeMainImages.length > 0) {
      const imageName = recipeMainImages[0].name;
      fetchImage3(imageName, 2);
      const clrName = removeFileExtension(imageName);
      setImageName(clrName);
    }
  }
// Handle select and delete actions

const handleSelectImageR = (image) => {
  if (recipeMainImages && recipeMainImages.length > 0) {
    const imageName = image.name;
    fetchImage3(imageName, 2);
    const clrName = removeFileExtension(imageName);
        const iNA = removeFileExtension2(imageName);
      setImageName(iNA.nameWithoutExt);   // sets filename without extension
      setRecImgExtn(iNA.extension); 
    // console.log(clrName, "recipe image clare name");
    setImageChange(true);
    // setImageName(clrName);
    setShowDrop(false);
  }
  
};

const handleDeleteImageR = async (id) => {
  const isConfirmed = window.confirm("Are you sure you want to delete this image?");
  
  if (isConfirmed) {
    try {
      const response = await fetch(`/api/delete-recipe-image/${id}`, {
        method: 'DELETE',
        credentials: 'include'
      });
      // alert(response);
      if (response.ok) {
        console.log("Image deleted successfully");
        
        setRecipeMainImages(prevImages => prevImages.filter(image => image.id !== id));
      } else {
        const errorData = await response.json();
        console.error("Failed to delete image:", errorData.message || "Unknown error");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  } else {
    console.log("Image deletion canceled");
  }
};

const handleUploadImageClick = () => {
  const fileInput = document.createElement("input");
  fileInput.type = "file";
  fileInput.accept = "image/jpeg,image/png,image/jpg,image/webp";

  fileInput.onchange = (event) => {
    const file = event.target.files[0];

    if (!file) return;

    // optional client-side size check (2MB)
    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "image/jpg",
      "image/webp"
    ];

    if (!allowedTypes.includes(file.type)) {
      alert("Only JPG, JPEG, PNG, and WEBP images are allowed");
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      alert("Image must be less than 5MB");
      return;
    }

    uploadImage(file);
  };

  fileInput.click();
};

const fetchRecImages = async () => {
  try {
    const response = await fetch('/api/getRecImages', {
      method: 'GET',
      credentials: 'include' // 🔥 REQUIRED
    });

    if (!response.ok) {
      const errorMessage = await response.text();
      throw new Error(errorMessage);
    }

    const data = await response.json();
    setRecipeMainImages(data);
    fetchImages2(data);

  } catch (error) {
    console.error("Error fetching data:", error);
  }
};

  const fetchImages2 = async (imagesLoop) => {
    // console.log("function fetchImages2 called");
    
    let urls = {};
    for (let img of imagesLoop) {
      try {
        const res = await axios.get(
          `/api/image-base?image-name=${img.name}`, 
          {
            responseType: 'blob',
            withCredentials: true
          }
        );
        const imageUrl = URL.createObjectURL(res.data);
        urls[img.name] = imageUrl;
      } catch (err) {
        console.error("Error fetching image:", err);
      }
    }
    setImageUrls(urls);
  };
const uploadImage = async (file) => {
  const formData = new FormData();
  formData.append("image", file);

    try {
      const response =
      await fetch(
        "/api/upload-recipe-image",

        {

          method:
            "POST",

          credentials:
            "include",

          headers: {

            "x-file-name":
              file.name

          },

          body:
            formData

        }
      );
    if (response.ok) {
      console.log("Image uploaded successfully");
      fetchRecImages(); // Refresh the image list after upload
    } else {
      const data =
      await response.json();

    alert(
      data.message
    );
    }
  } catch (error) {
    console.error("Error during image upload:", error);
  }
};
  // Utility function to remove the file extension
  const removeFileExtension = (filename) => {
    return filename.replace(/\.[^/.]+$/, ''); // Removes everything after the last dot (.)
  };
const removeFileExtension2 = (filename) => {
  const match = filename.match(/(.*)\.([^.]*)$/);
  if (match) {
    return {
      nameWithoutExt: match[1],
      extension: match[2],
    };
  }
  return { nameWithoutExt: filename, extension: '' };
};
const renderRecipeImages = () => {

  if (recipeMainImages.length === 0) {

    if (supAdmin === true) {
      return (
        <>
          <div className="image-search-container">
            <input
              type="text"
              placeholder="Search images..."
              value={imageSearch}
              onChange={(e) => setImageSearch(e.target.value)}
              className="image-search-input"
            />
          </div>

          <button
            className="upload-img-button"
            onClick={handleUploadImageClick}
          >
            Upload Image
          </button>
        </>
      );
    }

    return <div className='no-img-div'>No images available</div>;
  } else {

    // Filter images by search text
    const filteredRecipeImages = recipeMainImages.filter((image) =>
      removeFileExtension(image.name)
        .toLowerCase()
        .includes(imageSearch.toLowerCase())
    );

    // Sort filtered images
    const sortedRecipeImages = [...filteredRecipeImages].sort(
      (a, b) =>
        a.name.localeCompare(
          b.name,
          undefined,
          { sensitivity: "base" }
        )
    );

    if (supAdmin === true) {
      return (
        <>
          <div className="image-search-container">
            <input
              type="text"
              placeholder="Search images..."
              value={imageSearch}
              onChange={(e) => setImageSearch(e.target.value)}
              className="image-search-input"
            />
          </div>

          {sortedRecipeImages.map((image, index) => (
            <div
              key={index}
              className="recipe-image-item"
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <div className="ju-l-img">
                <img
                  src={imageUrls[image.name]}
                  alt={`Recipe Image ${index}`}
                  onClick={() => currentImage(image)}
                  className={`${smallMedia ? "loop-images-2" : "loop-images"}`}
                />
              </div>

              <p className='loop-image-names'>
                {removeFileExtension(image.name)}
              </p>

              {hoveredIndex === index && (
                <div className="overlay-buttons">
                  <button
                    className="select-button"
                    onClick={() => handleSelectImageR(image)}
                  >
                    Select
                  </button>

                  <button
                    className="delete-button"
                    onClick={() => handleDeleteImageR(image.id)}
                  >
                    Delete
                  </button>
                </div>
              )}
            </div>
          ))}

          {supAdmin && (
            <button
              className="upload-img-button"
              onClick={handleUploadImageClick}
            >
              Upload Image
            </button>
          )}
        </>
      );
    } else {
      return (
        <>
          <div className="image-search-container">
            <input
              type="text"
              placeholder="Search images..."
              value={imageSearch}
              onChange={(e) => setImageSearch(e.target.value)}
              className="image-search-input"
            />
          </div>

          {sortedRecipeImages.map((image, index) => (
            <div
              key={index}
              className="recipe-image-item"
              onClick={() => currentImage(image)}
            >
              <div className="ju-l-img">
                <img
                  src={imageUrls[image.name]}
                  alt={`Recipe Image ${index}`}
                  className={`${smallMedia ? "loop-images-2" : "loop-images-juice"}`}
                />
              </div>

              <p className='loop-image-names'>
                {removeFileExtension(image.name)}
              </p>
            </div>
          ))}
        </>
      );
    }
  }
};

const handleExpRec = () => {
  if (!recipesAll || recipesAll.length === 0) {
    alert("No recipes to export!");
    return;
  }

  let maxIngredients = 0;
  recipesAll.forEach((r) => {
    const count = r.ingredient_names
      ? r.ingredient_names.split(",").length
      : 0;
    if (count > maxIngredients) maxIngredients = count;
  });

  let headers = [
    "name",
    "favorite",
    "category",
    "preparation",
    "garnish",
    "procedures",
    "cost",
    "selling_price",
    "image",
    "qtty",
  ];

  for (let i = 1; i <= maxIngredients; i++) {
    headers.push(`product${i}`, `type${i}`, `quantity${i}`, `step${i}`);
  }

  const rows = recipesAll.map((r) => {
    const ingNames = r.ingredient_names ? r.ingredient_names.split(",") : [];
    const ingTypes = r.types ? r.types.split(",").map(type => String(type).trim().toLowerCase()): [];
    const ingQtys = r.quantities ? r.quantities.split(",") : [];
    const ingSteps = r.steps ? r.steps.split(",") : [];

    let row = [
      r.name || "",
      r.favorite ?? 0,
      r.category_name || "",
      `"${r.prep_steps || ""}"`,
      `"${r.garnish_name || ""}"`,
      `"${r.procedures || ""}"`,
      r.cost ?? 0,
      r.selling_price ?? 0,
      r.image
    ? r.image.replace(/\.[^/.]+$/, "")
    : "",
      r.qtty ?? 0,
    ];

    // Ingredients
  for (let i = 0; i < maxIngredients; i++) {

    row.push(
      ingNames[i] || "",
      ingTypes[i] || "",

      // export stored value directly
      ingQtys[i] || "",

      ingSteps[i] || ""
    );

  }
    return row.join(",");
  });

  // 4️⃣ Create CSV
  const csvContent = [headers.join(","), ...rows].join("\n");

  // 5️⃣ Download
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);

  link.href = url;
  link.download = `allRecipes_${uName}.csv`;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const [importErrors, setImportErrors] = useState([]);
const [fixes, setFixes] = useState({});
const [importFile, setImportFile] = useState(null);
const [importSummary, setImportSummary] = useState(null);
const [loading, setLoading] = useState(false);

const handleImpRec = () => {
  const input = document.createElement("input");
  input.type = "file";
  input.accept = ".csv";

  input.onchange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setImportFile(file);
    setLoading(true);

    const userData =
      JSON.parse(sessionStorage.getItem("userData"));

    const uId = userData?.id;
    const mId = userData?.selectedMachineIds;

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });

    try {

      const formData = new FormData();

      formData.append("file", file);
      formData.append("uId", uId);
      formData.append("mId", mId);

      const res = await axios.post(
        "/api/import-recipes/validate",
        formData,
        {
          withCredentials: true
        }
      );

      setImportSummary({
        total: res.data.total,
        valid: res.data.validCount,
        invalid: res.data.invalidCount
      });
      // console.log(res.data, "This is response data");
      
      setTabless(false);

      setImportErrors(
        res.data.errors || []
      );

      if (res.data.invalidCount > 0) {

        const confirmFix =
          window.confirm(
            `${res.data.invalidCount} recipes need correction. Fix them?`
          );

        if (!confirmFix) {
  setImportErrors([]);
  setImportSummary(null);
  setImportFile(null);
  setFixes({});
  setTabless(true);

  return;
}
      }

    } catch (err) {

      const errorData =
        err.response?.data;

      let msg =
        errorData?.message ||
        "Validation failed";

      if (errorData?.missingHeaders) {
        msg +=
          `\n\nMissing Columns:\n` +
          errorData.missingHeaders.join("\n");
      }

      if (errorData?.missingFields) {
        msg +=
          `\n\nMissing Fields:\n` +
          errorData.missingFields.join("\n");
      }

      if (errorData?.requiredHeaders) {
        msg +=
          `\n\nRequired Columns:\n` +
          errorData.requiredHeaders.join("\n");
      }

      alert(msg);

    } finally {

      setLoading(false);

    }
  };

  input.click();
};

const cnclImprt = () =>{
  setImportErrors([]);
  setImportSummary(null);
  setImportFile(null);
  setFixes({});
  setTabless(true);
}

const confirmImport = async () => {

  if (!importFile) return;

  setLoading(true);

  const userData =
    JSON.parse(
      sessionStorage.getItem("userData")
    );

  const uId =
    userData?.id;

  const mId =
    userData?.selectedMachineIds;

  try {

    const formData =
      new FormData();

    formData.append(
      "file",
      importFile
    );

    formData.append(

      "payload",

      JSON.stringify({

        uId,

        mId,

        fixes,

        invalidRows:

          importErrors?.map(error => error.row ) || []

      })

    );
    const res =
      await axios.post(

        "/api/import-recipes/confirm",

        formData,

        {

          withCredentials:
            true

        }

      );


    alert(

      `Successfully imported ${res.data.inserted} recipes`

    );


    // reset states

    setImportErrors([]);

    setFixes({});

    setImportSummary(null);

    setImportFile(null);


    fetchRecipes();

    setTabless(true);

  }

  catch (err) {

    console.error(err);


    alert(

      err.response?.data?.message

      ||

      "Import failed"

    );

  }

  finally {

    setLoading(false);

  }

};


const showFullDetails =
  tabless &&
  !importSummary &&
  (!importErrors || importErrors.length === 0);

const showImportDetails = !showFullDetails;
const handleStepChange = (index, value) => {
  const updatedProducts = [...products];

  updatedProducts[index].proStep = parseInt(value, 10);
  setProductStep(value);
  setProducts(updatedProducts);
};

const options = [
  {
    label: "Ingredients",
    options: ingredients
      .filter(i => i.type === "ingredient")
      .sort((a, b) => a.name.localeCompare(b.name))
      .map(i => ({
        value: i.name,
        label: i.name,
      })),
  },
  {
    label: "Juices",
    options: ingredients
      .filter(i => i.type === "juice")
      .sort((a, b) => a.name.localeCompare(b.name))
      .map(i => ({
        value: i.name,
        label: i.name,
      })),
  },
];
const customStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: "transparent",
    height: '100%',
    border: "none",
    color: "#EF7C32",
    boxShadow: "none",
    borderColor: "#EF7C32",
        "&:hover": {
      borderColor: "#EF7C32",
    },
  }),

  indicatorSeparator: (provided) => ({
    ...provided,
    backgroundColor: "#EF7C32",
    width: "1px",
  }),

  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: "#EF7C32",
    "&:hover": {
      color: "#EF7C32",
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#EF7C32",
  }),

  input: (provided) => ({
    ...provided,
    color: "#EF7C32",
  }),

  placeholder: (provided) => ({
    ...provided,
    color: "#EF7C32",
  }),

  menu: (provided) => ({
    ...provided,
    backgroundColor: "#BBBBBB",
  }),

  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "#007bff"
      : state.isFocused
      ? "#444"
      : "#2b2b2b",
    color: "black",
    backgroundColor: "#BBBBBB",
    cursor: "pointer",
  }),

  groupHeading: (provided) => ({
    ...provided,
    color: "#EF7C32",
    fontWeight: "bold",
    backgroundColor: "white",
    padding: "8px",
    textAlign: 'center'
  }),
};
return (
    <>
    <div className="sp-recipes">
    <div className="recipe-left" style={{display: smallMedia ? "none" : "block"}} ></div>
    <div
      className="full-details"
      style={{
        display:
          tabless &&
          !importSummary &&
          (!importErrors || importErrors.length === 0)
            ? "block"
            : "none"
      }}
    >
      {/* First div */}
      <div className={` ${smallMedia ? "details2a" : "details2 topDiv"}`}>
      <div className={` same select-sp ${smallMedia ? "same2 display2" : ""}`}>
         <div>
         Show
         </div>
          <div className={`main-Select ${smallMedia ? "sub-class2 main-Select2" : ""}`}>
        <select onChange={handlePerPageChange} value={perPage} className={`select-container ${smallMedia ? "select-container2" : ""}`}>
          {[5, 10, 15, 20, 25, 30].map((num, index) => (
            <option key={index} value={num} className='options' >{num}</option>
          ))}
        </select>
        </div>
        <div>
        Entries
        </div>
          </div>
        <div className={` same ${smallMedia ? "same2" : ""}`}>
          <div className={` same ${smallMedia ? "search-container2" : "search-container"}`}>
            <div className={`${smallMedia ? "shadeTriangle-sea2" : "shadeTriangle-sea"}`}></div>
        <input type="text" placeholder="Search" 
        className={` search-input ${smallMedia ? "search-input2" : ""}`}
         onChange={handleSearch} />
        <span className={` ${smallMedia ? "search-icon2" : "search-icon"}`} style={{ display: showIcon ? "block" : "none" }}>
          <SearchIcon className="sp-icon"/>
        </span>
      </div>
        </div>
          <div className={` same btn-add ${smallMedia ? "same2" : ""}`}> 
            <button onClick={toggleNew} className='btnAdd'>
            <div className={` ${smallMedia ? "shadeTriangle-adbnt2" : "shadeTriangle-adbnt"}`}></div>
              <div className="btn-both">
                <div className='icon'>
                <Plus className="sp-icon"/>
                </div>
                <span className="add-text">Add New Recipe</span>
              </div>
            </button>
          </div>
      </div>

      {/* Second div */}
      <div className="my-table" style={{ height: heightStyle() }}>
        <table className="customTable" style={{borderCollapse: "separate", borderSpacing: "0 0.911vh" }}>
          <thead className="tb-head borderRow">
            <tr className="my-row">
            <th className='na-sp-t'>
              <div className='left-tr-name' style={{display : smallMedia ? 'none' : 'block'}}></div>
              <div className="nm-class">
              Name
              </div>
              </th>
	      <th>Live</th>
              <th className='nd-td'>Selling Price ({currencyDash})</th>
              <th>Cost ({currencyDash})</th>
              <th className='sp-td sp-tr spp'>
              <div className="ac-class">
              Action
              </div>
            <div className='right-tr-action' style={{display : smallMedia ? 'none' : 'block'}}></div>
               </th>
            </tr>
          </thead>
          <tbody className="cu-body">
            {(searchTerm === "" ? currentRecipes : uniqueFilteredRecipes).map((recipe) => {

            const ids = recipe.ingredient_ids?.split(",") || [];
            const types =
              recipe.types?.split(",").map(t => t.toLowerCase()) || [];
            const quantities =
              recipe.quantities?.split(",").map(Number) || [];

            const recipeUnavailable = ids.some((id, index) => {
              const key = `${id}_${types[index]}`;
              const availableMl = pumpMap[key] || 0;
              const requiredMl = quantities[index] || 0;

              return availableMl < requiredMl;
            });

            return (
              <tr
                key={recipe.id}
                // className="custom-row"
                className={`custom-row ${
                  recipe.alcohol_ml &&
                  recipe.alcohol_ml
                    .split(",")
                    .reduce(
                      (sum, val) => sum + Number(val),
                      0
                    ) > 0
                    ? "redColor"
                    : ""
                }`}
              >
              <td className="f-td">
                <div className="recipe-name-cell">
                  <img
                    src={`/api/image-base?image-name=${recipe.image}`}
                    alt={recipe.name}
                    className="recipe-thumb"
                    onError={(e) => {
                      e.target.src = "/api/image-base?image-name=default-recipe.png"; // optional fallback
                    }}
                  />
                  <span title={recipe.name}>
                    {recipe.name.length > 15
                      ? `${recipe.name.slice(0, 15)}...`
                      : recipe.name}
                  </span>
                </div>
              </td>
              <td>
                {recipeUnavailable ? (
                  <span className='cross-row'
                    title="One or more ingredients are unavailable"
                  >
                    ✕
                  </span>
                ) : (
                  <span className='mark-row'
                    title="All ingredients are available"
                  >
                    ✓
                  </span>
                )}
              </td>
                <td className='s-td'>{recipe.selling_price}</td>
                <td className='t-td'>{recipe.cost > 0 ? `${recipe.cost.toFixed(4)}` : `${recipe.cost}`}</td>
                {/* <td>{recipe.cost.toFixed(4)}</td> */}
                <td className='sp-td fo-td'>
                  <div className='flex-container sp-llst'>
                  <button
                  onClick={() => handleFavoriteClick(recipe)}
                  className={`editconst  ${smallMedia ? "editconst2" : "favconst sp-reF"}`}
                >
                  <div className='triangle-container-idbnt'>
                    <div className='shadeTriangle-idbnt'></div>
                  </div>
                  <div className='favicon' style={{display : smallMedia ? 'none' : 'block'}}>
                  {recipe.favorite === 1 ? (
                    <div className='heart heart2 '>
                      <Fillheart className='sp-icon'/>
                    </div>
                  ) : (
                    <div className='heart heart2'>
                    <TranHeart className='sp-icon'/>
                    </div>
                  )
                  }
                  </div>
                  <div className="btnName">Favorite</div>
                </button>
                <button
                  onClick={() => handleDuplicateClick(recipe)} className={`editconst  ${smallMedia ? "editconst2" : "favconst dup-btn"}`}>
                  <div className='triangle-container-idbnt'>
                    <div className='shadeTriangle-idbnt'></div>
                  </div>
                  <div className='iIcon'>
                  <Dup className='sp-icon' style={{display : smallMedia ? 'none' : 'block'}} />
                  </div>
                  <div className="btnName">
                  Duplicate
                  </div>
                </button>
                <button onClick={() => handleEditClick(recipe)} 
                className={`editconst  ${smallMedia ? "editconst2" : "ed-sp"}`}
                >
                  <div  className='triangle-container-idbnt'>
                    <div className={` ${smallMedia ? "shadeTriangle-idbnt2" : "shadeTriangle-idbnt"}`}></div>
                  </div>
                  <div className='iIcon'>
                  <Edi className='sp-icon' style={{display : smallMedia ? 'none' : 'block'}}/>
                  </div>
                  
                 <div className="btnName">
                 Edit
                 </div>
                </button>
                <button
                  onClick={() => handleDeleteClick(recipe)} className={`deleteconst ${smallMedia ? "deleteconst2" : "dlt-sp re-dele"}`}>
                  <div className='triangle-container-idbntD'>
                    <div className={` ${smallMedia ? "shadeTriangle-idbntD2" : "shadeTriangle-idbntD"}`}></div>
                  </div>
                  <div className='iIcon'>
                  <Dele className='sp-icon'style={{display : smallMedia ? 'none' : 'block'}}/>
                  </div>
                  <div className="btnName">
                  Delete
                  </div>
                </button>
                  </div>
                  
                </td>
              </tr>
            );
            })}
          </tbody>
        </table>
      </div>

      {/* Third div */}
      <div className='bothDiv'> 
        <div className='bottomSh'>
          <div className='results'>
            Showing {Math.min(indexOfFirstRecipe + 1, uniqueFilteredRecipes.length)} to {Math.min(indexOfLastRecipe, uniqueFilteredRecipes.length)}
          </div>
          <div className='whiteClass'>
            (Total {uniqueFilteredRecipes.length} entries)
          </div>
        </div>
        <div className='imp-exp-btns'>
        <button onClick={handleExpRec} style={{display: recipesAll.length > 0 ? 'block' : 'none'}}
          className={`editconst  ${smallMedia ? "editconst2" : "dup-btn"}`}>
          <div className='triangle-container-idbnt'>
            <div className='shadeTriangle-idbnt'></div>
          </div>
          <div className="btnName">
            Export CSV
          </div>
        </button>
        <button onClick={handleImpRec}
          className={`editconst  ${smallMedia ? "editconst2" : "dup-btn"}`}>
          <div className='triangle-container-idbnt'>
            <div className='shadeTriangle-idbnt'></div>
          </div>
          <div className="btnName">
            Import CSV
          </div>
        </button>
        </div>
        <div className="pagination-info">
          <button onClick={() => paginate(currentPage - 1)} className='constbtn' disabled={currentPage === 1}>Previous</button>
          {Array.from(
            {
              length:
                Math.min(
                  totalPages,
                  currentPage === 1 || currentPage === totalPages
                    ? 3
                    : 3
                )
            },
            (_, index) => {

              let pageNumber;

              if (currentPage === 1) {
                pageNumber = index + 1;
              } else if (currentPage === totalPages) {
                pageNumber =
                  Math.max(1, totalPages - 2) + index;
              } else {
                pageNumber =
                  currentPage - 1 + index;
              }

              if (pageNumber > totalPages) return null;

              return (
                <button
                  key={pageNumber}
                  onClick={() => paginate(pageNumber)}
                  className={`pbtn ${
                    currentPage === pageNumber && smallMedia
                      ? "active12a2"
                      : currentPage === pageNumber
                      ? "active12"
                      : ""
                  }`}
                >
                  {pageNumber}
                </button>
              );
            }
          )}
          <button onClick={() => paginate(currentPage + 1)} className='constbtn' disabled={currentPage === totalPages}>Next</button>
        </div>
      </div>

      </div>
      <div className='imp-csv-dtls' style={{
        display:
          !tabless &&
          importSummary &&
          (importErrors || importErrors.length !== 0)
            ? "flex"
            : "none"
      }}>
        {importSummary && (
          <div className='summry-details'>
            <div className="sumry-hdr">Import Summary</div>
            <div className='sumry-ttl'>Total Recipes: {importSummary.total}</div>
            <div className='sumry-valid'>
              Valid Recipes: {importSummary.valid}
            </div>
            <div className='sumry-invalid'>
              Need Fix: {importSummary.invalid}
            </div>
          </div>
        )}

            {/* ================= Name ================= */}



        {importErrors.map(err => (
          <div
            key={err.row} className='imprt-errs' >
            <div className='sumry-hdr' style={{ marginBottom: 12 }}>
              Recipe {err.row} – {err.recipeName}
            </div>
            {err.issues.recipeName && (
              <div className='sumry-issu-cont'>

             <div className='issu-txt'>
                Recipe already exists: <b>{err.issues.recipeName.value}</b>
              </div>

              <input type="text" className='issu-pro-inpt' placeholder= "Enter new recipe name"
                value={
                  fixes[ err.row ]?.recipeName || ""
                }
                onChange={(e)=>
                  setFixes(prev=>({ ...prev,
                  [
                    err.row
                  ]:{
                  ...prev[
                  err.row
                  ],
                  recipeName:
                  e.target.value
                  }
              }))
              }
            />
            </div>

            )}
            {/* ================= CATEGORY ================= */}
            {err.issues.category && (
              <div className='sumry-issu-cont' style={{ marginBottom: 15 }}>
                <div className='issu-txt'>
                  Invalid Category: <b>{err.issues.category.value}</b>
                </div>

                <select
                  className='issu-sugg-list'
                  value={fixes[err.row]?.category || ""}
                  onChange={(e) =>
                    setFixes(prev => ({
                      ...prev,
                      [err.row]: {
                        ...prev[err.row],
                        category: e.target.value
                      }
                    }))
                  }
                >
                  <option value="">Select category</option>
                  {[...err.issues.category.suggestions]
                    .sort((a, b) => a.localeCompare(b))
                    .map(s => (
                      <option key={s} value={s}>
                        {s}
                      </option>
                  ))}
                </select>
              </div>
            )}

            {/* ================= IMAGE ================= */}
            {err.issues.image && (
              <div className='sumry-issu-cont' style={{ marginBottom: 15 }}>
                <div className='issu-txt'>
                  Invalid Image: <b>{err.issues.image.value}</b>
                </div>

                <select
                  className='issu-sugg-list'
                  value={fixes[err.row]?.image || ""}
                  onChange={(e) =>
                    setFixes(prev => ({
                      ...prev,
                      [err.row]: {
                        ...prev[err.row],
                        image: e.target.value
                      }
                    }))
                  }
                >
                  <option value="">Select image</option>
                  {[...err.issues.image.suggestions]
                  .sort((a, b) =>
                    a.replace(/\.[^/.]+$/, "")
                      .localeCompare(
                        b.replace(/\.[^/.]+$/, "")
                      )
                  )
                  .map(s => {
                    const displayName =
                      s.replace(/\.[^/.]+$/, "");

                    return (
                      <option key={s} value={s}>
                        {displayName}
                      </option>
                    );
                  })}
                </select>
              </div>
            )}

            {/* ================= PREPARATION ================= */}
            {err.issues.preparation && (
  <div
    className='sumry-issu-cont'
    style={{ marginBottom: 15 }}
  >
    <div className='issu-txt'>
      Invalid Preparation(s):
    </div>

    {err.issues.preparation.missing.map((missingItem) => (
      <div
        key={missingItem.index}
        style={{ marginBottom: 8 }}
      >

        <div className='issu-txt'>
          Missing: <b>{missingItem.value}</b>
        </div>

        <select
          className='issu-sugg-list'
          value={
            fixes[err.row]?.preparation?.[
              missingItem.index
            ] || ""
          }
          onChange={(e) =>
            setFixes(prev => ({
              ...prev,
              [err.row]: {
                ...prev[err.row],
                preparation: {
                  ...prev[err.row]?.preparation,
                  [missingItem.index]:
                    e.target.value
                }
              }
            }))
          }
        >
          <option value="">
            Select correct preparation
          </option>

          {[...err.issues.preparation.suggestions]
            .sort((a, b) => a.localeCompare(b))
            .map(s => (
              <option
                key={s}
                value={s}
              >
                {s}
              </option>
          ))}
        </select>

      </div>
    ))}
  </div>
)}

            {/* ================= GARNISH ================= */}
{err.issues.garnish && (
  <div
    className='sumry-issu-cont'
    style={{ marginBottom: 15 }}
  >
    <div className='issu-txt'>
      Invalid Garnish(es):
    </div>

    {err.issues.garnish.missing.map((missingItem) => (

      <div
        key={missingItem.index}
        style={{ marginBottom: 8 }}
      >

        <div className='issu-txt'>
          Missing: <b>{missingItem.value}</b>
        </div>

        <select
          className='issu-sugg-list'

          value={
            fixes[err.row]?.garnish?.[
              missingItem.index
            ] || ""
          }

          onChange={(e) =>
            setFixes(prev => ({

              ...prev,

              [err.row]: {

                ...prev[err.row],

                garnish: {

                  ...prev[err.row]?.garnish,

                  [missingItem.index]:
                    e.target.value

                }

              }

            }))
          }
        >

          <option value="">
            Select correct garnish
          </option>

          {[...err.issues.garnish.suggestions]
            .sort((a, b) => a.localeCompare(b))
            .map(s => (
              <option
                key={s}
                value={s}
              >
                {s}
              </option>
          ))}

        </select>

      </div>

    ))}
  </div>
)}

            {/* ================= PRODUCTS ================= */}
            {err.issues.products && (
              <div className='sumry-issu-cont'>
                <div className='issu-txt'>Product Issues</div>

                {err.issues.products.map((p, idx) => (
                  <div key={idx}>
                    <div className='issu-txt' style={{ paddingLeft: '0.5%'}}>
                      Product #{p.index} –{" "}
                      <b>{p.name}</b>{" "}
                      {p.type && (
                        <span>
                          ( {p.type} )
                        </span>
                      )}
                    </div>

                    {/* Invalid Type */}
                    {p.message && (
                      <div className='issu-txt'>
                        {p.message}
                      </div>
                    )}

                    {/* Suggestions */}
                    {p.suggestions && (
                      <select
                        className='issu-sugg-list'
                        onChange={(e) =>
                          setFixes(prev => ({
                            ...prev,
                            [err.row]: {
                              ...prev[err.row],
                              products: {
                                ...prev[err.row]?.products,
                                [p.index]: e.target.value
                              }
                            }
                          }))
                        }
                      >
                        <option value="">Select correct product</option>
                        {[...p.suggestions]
                          .sort((a, b) => a.localeCompare(b))
                          .map(s => (
                            <option
                              key={s}
                              value={s}
                            >
                              {s}
                            </option>
                        ))}
                      </select>
                    )}
                  </div>
                ))}
              </div>
            )}
            {/* some of all products */}
            {err.issues.productsTotal && (
            <div className='sumry-issu-cont' style={{ marginBottom: 16 }}>

                <div className='issu-txt'>
                  {err.issues.productsTotal.message}
                </div>

                {err.issues.productsTotal.products.map((prod, idx) => {

                  const currentValue =
                    fixes[err.row]?.productQuantities?.[prod.index] ??
                    prod.qty;

                  return (
                    <div
                      key={idx}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: 'space-between',
                        width: '35%',
                      }}
                      className='issu-sugg-list'
                    >
                      <span >
                        {prod.name} ({prod.type})
                      </span>
                      <div>
                      <input
                        
                        type="number"
                        min="0"
                        max="100"
                        value={currentValue}
                        className='issu-pro-inpt'
                        onWheel={(e) => e.target.blur()}
                        onChange={(e) => {

                          const value = e.target.value;

                          setFixes(prev => ({
                            ...prev,
                            [err.row]: {
                              ...prev[err.row],
                              productQuantities: {
                                ...prev[err.row]?.productQuantities,
                                [prod.index]: value
                              }
                            }
                          }));

                        }}
                      />

                      <span>ml</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        ))}
        {importSummary && (
          <div className='imprt-errs imprt-actons'>
            <button
              onClick={confirmImport}
              disabled={loading}
              className='csv-confrm-imprt-btn'
            >
              {loading ? "Processing..." : "Import All Recipes"}
            </button>
            <button
              onClick={cnclImprt}
              // disabled={loading}
              className='csv-confrm-imprt-btn'
            >
              {loading ? "Processing..." : "Cancel Import"}
            </button>
          </div>
        )}
      </div>

                                  {/* Edit */}
                                  
      <div style={{display: editR ? "block" : "none"}}  className={` ${smallMedia ? "new-r-p2" : "new-r-p"}`}>
      <div className={` ${smallMedia ? 'sub-class-2a' : 'sub-class'}`}>
      <div className={` ${smallMedia ? "vertical-div1-2" : "vertical-div1"}`}>
        <div className={` ${smallMedia ? "t-main-div-2" : "t-main-div"}`}>
        <div className={` ${smallMedia ? "mainpic-2" : "mainpic"}`}>
        <div className={` ${smallMedia ? "shadeTriangle-imageL" : "shadeTriangle-imageL-2"}`}></div>
          <img src={selectedImage2} 
          alt="image" className="selected-image"/>
        </div>
        </div>
        {/* <div className="images-container"> */}
          <div className={` ${smallMedia ? "drop-imge-2" : "drop-imge"}`} style={{display: showDrop ? "block": "none"}}>
            {renderRecipeImages()}
          </div>
          <div className={` ${smallMedia ? "t-main-div2-2" : "t-main-div2"}`} >
            <div  className={` ${smallMedia ? "selectImage-2" : "selectImage"}`} onClick={showContainer} >
              <div className={` ${smallMedia ? "shadeTriangle-image-2" : "shadeTriangle-image"}`}></div>
            <img src={selectedImage} alt="icon" className="drop-image" />
            </div>
            <div className={` ${smallMedia ? "selectedName-2" : "selectedName"}`}>
              <div className={` ${smallMedia ? "nameLeft-2" : "nameLeft-aab"}`}></div>
            <input type="text" readOnly className={` ${smallMedia ? "select-I-N-2" : "select-I-N"}`} value={imageName} />
            <div className={` ${smallMedia ? "nameRight-2" : "nameRight-aab"}`}></div>
            </div> 
          </div>
      </div>
      {/* </div> */}
      <div className={` ${smallMedia ? "vertical-div2-2" : "vertical-div2"}`}>
      <div className={` ${smallMedia ? "div2-1-2" : "div2-1"}`}>
      <div className="full-name">
      <div className="f-name sm-txt-a">Name </div>
      <div className={` ${smallMedia ? "recipe-name-2" : "recipe-name"}`}>
        <div className={` ${smallMedia ? "nameLeft-2" : "nameLeft-b"}`}></div>
        <input type="text" value={reName} 
        className={`${smallMedia ? 're-name' : 're-name-2'}`} 
        onChange={(event) => setReName(event.target.value)} 
        placeholder="Enter name" />
        <div className={` ${smallMedia ? "nameRight-2" : "nameRight-b"}`}></div>
        </div>
      </div>
      <div className={`${smallMedia ? "favorite-btn-2" :'favorite-btn' }`}>
      <div className='fav-t-cnt'>
      <div className='fav-head sm-txt-a'>Favorite</div>
      </div>
      <div className='fav-ring-cnt'>
      <div className="customDiv" onClick={()=>{setFavorite(false)}} style={{display : favorite ? 'block' : 'none'}}>
      <div className={` ringF ${smallMedia ? "ringF-2" :'' }`}>
        <div className='dotF'></div>
      </div>
      </div>
      <div className="customDiv" onClick={()=>{setFavorite(true)}} style={{display : favorite ? 'none' : 'block'}}>
      <div className='ringFf'></div>
      </div>
      </div>
      </div>
      </div>
      <div className={` ${smallMedia ? "div2-2-2" : "div2-2"}`}>
      <div className='pre-container'>
      <div className="pre-head sm-txt-a">Preparation</div>    
    <div  className={`image-selector-button ${smallMedia ? "image-selector-button-2" : ""}`}>
      <div className={` ${smallMedia ? "nameLeft-2" : "nameLeft-a"}`}></div>
      <div className={`${smallMedia ? "pre-text-box-2" : "pre-text-box"}`} onClick={() => {setArowDwn(true); setShowPreparationList(!showPreparationList)}}>
        {selectedPreparations.length === 0 ? (
          <div className='st-txt'>Select Steps...</div>
        ) : (
          <div className='selected-prep-container'>
            {selectedPreparations.length > 0 && (
              <div className={`selected-div ${smallMedia ? "selected-div-2" : ""}`}>
                <div className='sele-image'>
                  <img
                    src={
                      selectedPreparations[selectedPreparations.length - 1].imageName
                    }
                    alt="Selected Preparation"
                    className="selected-prep"
                  />
                </div>

                <div className='sele-name'>
                  <label>
                    {
                      selectedPreparations[selectedPreparations.length - 1].name
                    }
                  </label>
                </div>

                <div className='mCl'></div>
              </div>
            )}
          </div>
        )}
      </div>
      <div className='dtls-cont-selected'>
        <div className='selected-lnth'>{selectedPreparations.length === 0 ? '' : selectedPreparations.length }</div>
         <div className= {`arow-dsgn ${arowDwn ? 'dwn-arow' : 'up-arow'}`} onClick={(e) => {setArowDwn(!arowDwn); setShowPreparationList(false)}}><div className='arrow-btn'>{"<"}</div></div>
      </div>
        
      <div className={` ${smallMedia ? "nameRight-2" : "nameRight-a"}`}></div>
    </div>
      <div
        className='all-preps'
        style={{ display: arowDwn ? 'none' : 'block' }}
      >
        {selectedPreparations.map((prep, index) => (
          <div className='prep-item' key={index}>
            <img
              src={prep.imageName}
              alt={prep.name}
              className='prep-img'
            />

            <span className='prep-name'>
              {prep.name}
            </span>
            <div className="closeP" onClick={() => handleRemovePrep(prep)}><div>X</div></div>
          </div>
        ))}
      </div>
       <div className={'prep-cont-active'} style={{display: showPreparationList ? 'block' : 'none'}}>
          <div className={`image-list ${smallMedia ? 'image-list-2' : ''}`}>
            {renderPreparationImages()}
          </div>
      </div>
      </div> 
      <div className="garnishes" >
        <div className="pre-head sm-txt-a">Garnishes</div>
        <div className={`image-selector-button ${smallMedia ? "image-selector-button-2" : ""}`}>
        <div className={` ${smallMedia ? "nameLeft-2" : "nameLeft-a"}`}></div>
        <div className={`${smallMedia ? "pre-text-box-2" : "pre-text-box"}`}
         onClick={() => {setArowDwnGar(true); setShowImageList(!showImageList)}}>
          {selectedImages.length === 0 ? (
            <div className='st-txt'>Select Garnishes...</div>
          ) : (
            <div className='selected-prep-container'>
              {selectedImages.length > 0 && (
                <div className={`selected-div ${smallMedia ? "selected-div-2" : ""}`}>
                  <div className='sele-image'>
                    <img
                      src={
                        selectedImages[selectedImages.length - 1].imageName
                      }
                      alt="Selected Image"
                      className="selected-prep"
                    />
                  </div>

                  <div className='sele-name'>
                    <label>
                      {
                        selectedImages[selectedImages.length - 1].name
                      }
                    </label>
                  </div>

                  <div className='mCl'>
                    {/* remove button */}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
        <div className='dtls-cont-selected'>
          <div className='selected-lnth'>{selectedImages.length === 0 ? '' : selectedImages.length }</div>
           <div className= {`arow-dsgn ${arowDwnGar ? 'dwn-arow' : 'up-arow'}`} onClick={(e) => {setArowDwnGar(!arowDwnGar); setShowImageList(false)}}><div className='arrow-btn'>{"<"}</div></div>
        </div>

          <div className={` ${smallMedia ? "nameRight-2" : "nameRight-a"}`}></div>
        </div>
       <div className={'prep-cont-active'} style={{display: showImageList ? 'block' : 'none'}}>
        <div className={`image-list ${smallMedia ? "image-list-2" : ""}`}>
          {renderGarnishImages()}
        </div>
        </div>
              <div
        className='all-preps'
        style={{ display: arowDwnGar ? 'none' : 'block' }}
      >
        {selectedImages.map((prep, index) => (
          <div className='prep-item' key={index}>
            <img
              src={prep.imageName}
              alt={prep.name}
              className='prep-img'
            />

            <span className='prep-name'>
              {prep.name}
            </span>
            <div className="closeP" onClick={() => handleRemovePreparation(prep)}><div>X</div></div>
          </div>
        ))}
      </div>
      </div>
      </div>
      <div className={` ${smallMedia ? "div2-3-2" : "div2-3"}`}>
      <div className="proc-head">Procedure</div>
        <div className={` ${smallMedia ? "procedure-2" : "procedure"}`}>
      <div  className={`${smallMedia ? 'textLeft' : 'textLeft-2'}`}></div>
        <div className="text-area">
        <textarea name="postContent" className={`${smallMedia ? 'textarea-box' : 'textarea-box-2'}`} onChange={(event) => setTextArea(event.target.value)} value={textArea} placeholder="Type Procedure..." />
        </div>
      <div  className={`${smallMedia ? 'textRight' : 'textRight-2'}`}></div>
        </div>
      </div>
      <div className={` ${smallMedia ? "div2-4-2" : "div2-4"}`}>
        <div className= "selling-p">
          <div className="se-head sm-txt-a">Selling Price</div>
          <div className= {`  ${smallMedia ? "selling-area-2" : "selling-area"}`}>
          <div className={` ${smallMedia ? "nameLeft-2" : "nameLeft-b"}`}></div>
          <div className="sell-input">
            <input type="number"  
            className={`${smallMedia ? 'sell-text-box' : 'sell-text-box-2'}`}
            onWheel={(e) => e.target.blur()}
            onChange={(event) => setSellingPrice(event.target.value)} value={sellingPrice} placeholder="Selling Price"/>
          </div>
          <div className={` ${smallMedia ? "nameRight-2" : "nameRight-b"}`}></div>

          </div>
        </div>
        <div className="categories">
            <div className="ce-head sm-txt-a">Categories</div>
            <div className={` ${smallMedia ? "cate-box-2" : "cate-box"}`}>
          <div className={` ${smallMedia ? "nameLeft-2" : "nameLeft-a"}`}></div>
          <div className="cate-select-box"> 
        <select
        value={cate}
        onChange={(e) => {
          setCate(e.target.value);
          const selectedCategory = getCats.find(getCats => getCats.name === e.target.value);
          if (selectedCategory) {
            setGetedCatId(selectedCategory.id)
          }
        }}
        className="select-cate" >
          <option>Choose Category</option>
          {[...getCats]
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((getCat, index) => (
              <option key={index} value={getCat.name}>
                {getCat.name}
              </option>
            ))}
          </select> 

          </div>
          <div className={` ${smallMedia ? "nameRight-2" : "nameRight-a"}`}></div>
            </div>
        </div>
      </div>
      </div>
      </div>
      <div className={` ${smallMedia ? "dynamic-table-2" : "dynamic-table"}`}>

      <div className={` ${smallMedia ? "choose-p-2" : "choose-p"}`}>
      <div className={`choosing-pro ${smallMedia ? "choosing-pro-2" : ""}`}>
      <div className="product-choose">
        <div className="cho-head">Name</div>
        <div className={`choose-box ${smallMedia ? "choose-box-2" : ""}`}>
          <div className={` ${smallMedia ? "nameLeft-2" : "nameLeft-ac"}`}></div>
          <Select
            options={options}
            isSearchable={true}
            menuPlacement="auto"
            placeholder="Select Name..."
            styles={customStyles}
            className="choosen-prod"
            classNamePrefix="rs"
            value={
              selectedProduct
                ? { value: selectedProduct, label: selectedProduct }
                : null
            }
            onChange={(selected) => {
              const productName = selected?.value || "";

              setSelectedProduct(productName);

              const selectedIngredient = ingredients.find(
                ingredient => ingredient.name === productName
              );

              if (selectedIngredient) {
                setGetCost(selectedIngredient.cost_ml);
                setGetId(selectedIngredient.unique_id);
                setSelIngreType(selectedIngredient.type);
                setSnglAlco(
                  selectedIngredient.alcohol
                    ? selectedIngredient.alcohol
                    : 0
                );
              } else {
                setGetCost("");
                setGetId("");
                setSelIngreType("");
                setSnglAlco(0);
              }
            }}
          />
          <div className={` ${smallMedia ? "nameRight-2" : "nameRight-ac"}`}></div>
        </div>
      </div>
      <div className="product-q" >
        <div className='qty-head sm-txt-a'>Quantity(ml)</div>
        <div className={` p-q-cont ${smallMedia ? "p-q-cont-2" : ""}`}>
          <div className="p-q-cont-left"></div>
          <div className="quantity-area">
            <input
              type="number"
              value={productValue}
              onChange={(e) => setProductValue(e.target.value)}
              placeholder="Quantity"
              onWheel={(e) => e.target.blur()} 
              className={`${smallMedia ? "quantity-te-2" : "quantity-te"}`}
            />
          </div>
          <div className="p-q-cont-right"></div>
        </div>
      </div>
      <div className="product-a">
        <div className='qty-head sub-cl2 sm-txt-a'>Action</div>
        <div className={`${smallMedia ? "p-a-btn-2" : "p-a-btn"}`} onClick={handleAddProduct}>
          <div className={`${smallMedia ? "shadeTriangle-quan-2" : "shadeTriangle-quan"}`}></div>
          <button className="add-btn">
            <span className="sub-symb">+</span>Add
          </button>
        </div>
      </div>
    </div> 
      
    <div style={{display: smallMedia ? 'none' : 'block'}} className='allBtns'>
      <div className="btnClose" >
         <div className='total-ml'>
         <label className='sm-txt-a'>Total(ml)</label>
         <div className="recal-btn-2">
         <div className="nameLeft-acca"></div>
         <input className="recycle-btn no-spinners" type='number' onChange={(e) => setReqMl(e.target.value)}  
           value={total}
           readonly
         /> 
         <div className="nameRight-acca"></div>
         </div>
         </div>
      
        <div className="new-close-cont-2" onClick={handleClose}>
            <div className='shadeTriangle-recal-2'></div>
          <button  className="close-btn">
          <label className='close-icon-2'>
            <Clo_icon className='sp-icon'/>
          </label>
          Close
          </button>
        </div>
        <div className="new-close-cont-2" onClick={backTbl}>
        <div className='shadeTriangle-recal-2'></div>
        <button  className="close-btn">
        <label className='close-icon-2'>
        <Sav_icon className='sp-icon'/>
          </label>
        {/* <img src={saveIcon} alt="icon" className="close-icon-2" /> */}
        Save</button>
        </div>
      </div>
      </div>
      </div>
      <div className={` ${smallMedia ? "only-table-2" : "only-table"}`}>
      {/* <h2>Product Table</h2> */}
      <div className="product-t">
      <table className='product-t-tbl'>
        <thead style={{display: showDrop ? 'none' : ''}}>
          <tr>
            <th>Name</th>
            <th>Quantity</th>
            <th>Disp at</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody className="custombody">
          {products.map((product, index)=>(
            <tr key={index} className="data-loop">
              
              <td className='for-re'>
                <div className={`t-data c-name ${smallMedia ? "t-name-2" : "t-name"}`} >
                  <div  className={` p-table-name ${smallMedia ? "p-table-name-2" : ""}`}>
                    <div className={` ${smallMedia ? "nameLeft-2" : "nameLeft-ca"}`}></div>
                    <div className='dy-name'>
                      {product.name}
                    </div>
                    <div className={` ${smallMedia ? "nameRight-2" : "nameRight-ca"}`}></div>
                  </div>
                </div>
              </td>

              <td  className='for-re'>
                <div  className={`t-data ${smallMedia ? "t-quantity-2" : "t-quantity"}`}> 
                  <div className={`${smallMedia ? "shadeTriangle-quan-2" : "shadeTriangle-quan"}`} ></div> 
                  <div className={`p-table-quantity ${smallMedia ? "p-table-quantity-2" : ""}`}>
                    {product.value ? `${Math.floor(product.value)}` : ''}
                  </div>
                </div>
              </td>

              <td className='for-re'>
                
                <div className={`t-data ${smallMedia ? "t-quantity-2" : "t-quantity"}`} >
                  <div className={`${smallMedia ? "shadeTriangle-quan-2" : "shadeTriangle-quan"}`} ></div>
                    <div className={`p-table-quantity ${smallMedia ? "p-table-quantity-2" : ""}`}>
                    <select 
                    style={{background: 'transparent', textAlign: 'center', border: 'none', width: '100%'}}
                  
                      value={product.proStep || ""}
                      onChange={(e) => handleStepChange(index, e.target.value)}
                      className={`p-table-quantity p-btn ${smallMedia ? "p-table-quantity-2" : ""}`}
                    >
                      <option style={{background: '#EF7C32', color: 'white'}} value="">Select</option>
                      {[1, 2, 3, 4, 5].map((step) => (
                        <option style={{background: '#EF7C32', color: 'white'}} key={step} value={step}>
                          {step}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
            </td>
              
              
              <td className='for-re'>
                <div className={`t-data ${smallMedia ? "t-action-2" : "t-action"}`}
                 onClick={() => handleDeleteProduct(index)}>
                  <div className={`${smallMedia ? "shadeTriangle-quan-2" : "shadeTriangle-quan"}`}></div>
                  <div className="p-t-a-btn">
                  <button className="p-btn">
                    <span className='span-del'>Del</span>
                  </button>
                  </div> 
                </div>
              </td>
              
            </tr>
          ))}
        </tbody>
      </table>
      </div>
      
      <div style={{display: smallMedia ? 'block' : 'none'}}>
      <div className={` ${smallMedia ? "btnClose-2" : "btnClose"}`}>
      <div className="recal-btn">
      <div className="recal-Left"></div>
      <div className='shadeTriangle-recal'></div>
      <button className="recycle-btn"> {total} </button>
      <div className="recal-Right"></div>
      </div>
        <div className="new-close-cont" onClick={handleClose}>
            <div className='shadeTriangle-recal'></div>
          <button  className="close-btn">
          <img src={cancelIcon} alt="icon" className="close-icon" />
          Close
          </button>
        </div>
        <div className="new-close-cont" onClick={backTbl}>
        <div className='shadeTriangle-recal'></div>
        <button  className="close-btn">
        <img src={saveIcon} alt="icon" className="close-icon" />
        Save</button>
        </div>
      </div>
      </div>
        <div className='prod-tbl-btm'>
          <div>Cost: <span>{grandTotal.toFixed(2)}</span></div>
          <div>
            Alcohol: <span>{total > 0 ? ((Number(ttlalco) / Number(total)) * 100).toFixed(2) : "0.00"}%</span>
          </div>
        </div>
      </div>
      
      </div>
    </div>
                          {/* / Edit */}
                           {/* New */}
  <div style={{display: newRec ? "block" : "none"}}  className={` ${smallMedia ? "new-r-p2" : "new-r-p"}`}>
      <div className={` ${smallMedia ? 'sub-class-2a' : 'sub-class'}`}>
      <div className={` ${smallMedia ? "vertical-div1-2" : "vertical-div1"}`}>
        <div className={` ${smallMedia ? "t-main-div-2" : "t-main-div"}`}>
        <div className={` ${smallMedia ? "mainpic-2" : "mainpic"}`}>
        <div className={` ${smallMedia ? "shadeTriangle-imageL" : "shadeTriangle-imageL-2"}`}></div>
          <img src={selectedImage2} alt="image" className="selected-image"/>
        </div>
        </div>
          <div className={` ${smallMedia ? "drop-imge-2" : "drop-imge"}`} style={{display: showDrop ? "block": "none"}}>
            {renderRecipeImages()}
          </div>
          <div className={` ${smallMedia ? "t-main-div2-2" : "t-main-div2"}`} >
            <div  className={` ${smallMedia ? "selectImage-2" : "selectImage"}`} onClick={showContainer} >
              <div className={` ${smallMedia ? "shadeTriangle-image-2" : "shadeTriangle-image"}`}></div>
            <img src={selectedImage} alt="icon" className="drop-image" />
            </div>
            <div className={` ${smallMedia ? "selectedName-2" : "selectedName"}`}>
              <div className={` ${smallMedia ? "nameLeft-2" : "nameLeft-aab"}`}></div>
              <div className='name-inpt'>
              <input type="text" readOnly className={` ${smallMedia ? "select-I-N-2" : "select-I-N"}`} value={imageName} />
              </div>
            <div className={` ${smallMedia ? "nameRight-2" : "nameRight-aab"}`}></div>
            </div> 
          </div>
      </div>
      {/* </div> */}
      <div className={` ${smallMedia ? "vertical-div2-2" : "vertical-div2"}`}>
      <div className={` ${smallMedia ? "div2-1-2" : "div2-1"}`}>
      <div className="full-name">
      <div className="f-name sm-txt-a">Name </div>
      <div className={` ${smallMedia ? "recipe-name-2" : "recipe-name"}`}>
        <div className={` ${smallMedia ? "nameLeft-2" : "nameLeft-b"}`}></div>
        <input type="text" value={reName} 
        className={`${smallMedia ? 're-name' : 're-name-2'}`} 
        onChange={(event) => setReName(event.target.value)} 
        placeholder="Enter name" />
        <div className={` ${smallMedia ? "nameRight-2" : "nameRight-b"}`}></div>
        </div>
      </div>
            <div className={`${smallMedia ? "favorite-btn-2" :'favorite-btn' }`}>
      <div className='fav-t-cnt'>
      <div className='fav-head sm-txt-a'>Favorite</div>
      </div>
      <div className='fav-ring-cnt'>
      <div className="customDiv" onClick={()=>{setFavorite(false)}} style={{display : favorite ? 'block' : 'none'}}>
      <div className={` ringF ${smallMedia ? "ringF-2" :'' }`}>
        <div className='dotF'></div>
      </div>
      </div>
      <div className="customDiv" onClick={()=>{setFavorite(true)}} style={{display : favorite ? 'none' : 'block'}}>
      <div className='ringFf'></div>
      </div>
      </div>
      </div>
      </div>
      <div className={` ${smallMedia ? "div2-2-2" : "div2-2"}`}>
      <div className='pre-container'>
      <div className="pre-head sm-txt-a">Preparation</div>    
    <div  className={`image-selector-button ${smallMedia ? "image-selector-button-2" : ""}`}>
      <div className={` ${smallMedia ? "nameLeft-2" : "nameLeft-a"}`}></div>
      <div className={`${smallMedia ? "pre-text-box-2" : "pre-text-box"}`} onClick={() => { setArowDwn(true);  setShowPreparationList(!showPreparationList)}}>
  {selectedPreparations.length === 0 ? (
    <div className='st-txt'>Select Steps...</div>
  ) : (
    <div className='selected-prep-container'>
  {selectedPreparations.length > 0 && (
    <div className={`selected-div ${smallMedia ? "selected-div-2" : ""}`}>
      <div className='sele-image'>
        <img
          src={
            selectedPreparations[selectedPreparations.length - 1].imageName
          }
          alt="Selected Preparation"
          className="selected-prep"
        />
      </div>

      <div className='sele-name'>
        <label>
          {
            selectedPreparations[selectedPreparations.length - 1].name
          }
        </label>
      </div>

      <div className='mCl'></div>
    </div>
  )}
</div>
  )}
</div>
      <div className='dtls-cont-selected'>
        <div className='selected-lnth'>{selectedPreparations.length === 0 ? '' : selectedPreparations.length }</div> <div className= {`arow-dsgn ${arowDwn ? 'dwn-arow' : 'up-arow'}`} onClick={(e) => {setArowDwn(!arowDwn); setShowPreparationList(false)}}><div className='arrow-btn'>{"<"}</div></div>
      </div>
      <div className={` ${smallMedia ? "nameRight-2" : "nameRight-a"}`}>  </div>
    </div>
      <div
        className='all-preps'
        style={{ display: arowDwn ? 'none' : 'block' }}
      >
        {selectedPreparations.map((prep, index) => (
          <div className='prep-item' key={index}>
            <img
              src={prep.imageName}
              alt={prep.name}
              className='prep-img'
            />

            <span className='prep-name'>
              {prep.name}
            </span>
            <div className="closeP" onClick={() => handleRemovePrep(prep)}><div>X</div></div>
          </div>
        ))}
      </div>    
     <div className={'prep-cont-active'} style={{display: showPreparationList ? 'block' : 'none'}}>
        <div className={`image-list ${smallMedia ? 'image-list-2' : ''}`}>
          {renderPreparationImages()}
        </div>
      </div>
      </div> 
      <div className="garnishes" >
        <div className="pre-head sm-txt-a">Garnishes</div>
        <div className={`image-selector-button ${smallMedia ? "image-selector-button-2" : ""}`}>
        <div className={` ${smallMedia ? "nameLeft-2" : "nameLeft-a"}`}></div>
        <div className={`${smallMedia ? "pre-text-box-2" : "pre-text-box"}`} onClick={() => {setShowImageList(!showImageList); setArowDwnGar(true)}}>
          {selectedImages.length === 0 ? (
            <div className='st-txt'>Select Garnishes...</div>
          ) : (
            <div className='selected-prep-container'>
              {selectedImages.length > 0 && (
                <div className={`selected-div ${smallMedia ? "selected-div-2" : ""}`}>
                  <div className='sele-image'>
                    <img
                      src={
                        selectedImages[selectedImages.length - 1].imageName
                      }
                      alt="Selected Image"
                      className="selected-prep"
                    />
                  </div>

                  <div className='sele-name'>
                    <label>
                      {
                        selectedImages[selectedImages.length - 1].name
                      }
                    </label>
                  </div>

                  <div className='mCl'>
                    {/* remove button */}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
        <div className='dtls-cont-selected'>
          <div className='selected-lnth'>{selectedImages.length === 0 ? '' : selectedImages.length }</div> 
           <div className= {`arow-dsgn ${arowDwnGar ? 'dwn-arow' : 'up-arow'}`} onClick={(e) =>{setShowImageList(false); setArowDwnGar(!arowDwnGar)}}><div className='arrow-btn'>{"<"}</div></div>
        </div>
        <div className={` ${smallMedia ? "nameRight-2" : "nameRight-a"}`}></div>
        </div>
       <div className={'prep-cont-active'} style={{display: showImageList ? 'block' : 'none'}}>
        <div className={`image-list ${smallMedia ? "image-list-2" : ""}`}>
          {renderGarnishImages()}
        </div>
        </div>
              <div
        className='all-preps'
        style={{ display: arowDwnGar ? 'none' : 'block' }}
      >
        {selectedImages.map((prep, index) => (
          <div className='prep-item' key={index}>
            <img
              src={prep.imageName}
              alt={prep.name}
              className='prep-img'
            />

            <span className='prep-name'>
              {prep.name}
            </span>
            <div className="closeP" onClick={() => handleRemovePreparation(prep)}><div>X</div></div>
          </div>
        ))}
      </div>
      </div>

      </div>
      <div className={` ${smallMedia ? "div2-3-2" : "div2-3"}`}>
      <div className="proc-head">Procedure</div>
        <div className={` ${smallMedia ? "procedure-2" : "procedure"}`}>
      <div  className={`${smallMedia ? 'textLeft' : 'textLeft-2'}`}></div>
        <div className="text-area">
        <textarea name="postContent" className={`${smallMedia ? 'textarea-box' : 'textarea-box-2'}`} onChange={(event) => setTextArea(event.target.value)} value={textArea} placeholder="Type Procedure..." />
        </div>
      <div  className={`${smallMedia ? 'textRight' : 'textRight-2'}`}></div>
        </div>
      </div>
      <div className={` ${smallMedia ? "div2-4-2" : "div2-4"}`}>
        <div className= "selling-p">
          <div className="se-head sm-txt-a">Selling Price</div>
          <div className= {`  ${smallMedia ? "selling-area-2" : "selling-area"}`}>
          <div className={` ${smallMedia ? "nameLeft-2" : "nameLeft-aab"}`}></div>
          <div className="sell-input">
            <input type="number"  
            className={`${smallMedia ? 'sell-text-box' : 'sell-text-box-2'}`}
            onChange={(event) => setSellingPrice(event.target.value)} value={sellingPrice} placeholder="Selling Price"
            onWheel={(e) => e.target.blur()}
            />
          </div>
          <div className={` ${smallMedia ? "nameRight-2" : "nameRight-aab"}`}></div>

          </div>
        </div>
        <div className="categories">
            <div className="ce-head sm-txt-a">Categories</div>
            <div className={` ${smallMedia ? "cate-box-2" : "cate-box"}`}>
          <div className={` ${smallMedia ? "nameLeft-2" : "nameLeft-a"}`}></div>
          <div className="cate-select-box"> 
        <select
        value={cate}
        onChange={(e) => {
          setCate(e.target.value);
          const selectedCategory = getCats.find(getCats => getCats.name === e.target.value);
          if (selectedCategory) {
            setGetedCatId(selectedCategory.id)
          }
        }}
        className="select-cate" >
          <option>Choose Category</option>
          {[...getCats]
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((getCat, index) => (
              <option key={index} value={getCat.name}>
                {getCat.name}
              </option>
            ))}
          </select> 

          </div>
          <div className={` ${smallMedia ? "nameRight-2" : "nameRight-a"}`}></div>
            </div>
        </div>
      </div>
      </div>
      </div>
      <div className={` ${smallMedia ? "dynamic-table-2" : "dynamic-table"}`}>

      <div className={` ${smallMedia ? "choose-p-2" : "choose-p"}`}>
      <div className={`choosing-pro ${smallMedia ? "choosing-pro-2" : ""}`}>
      <div className="product-choose">
        <div className="cho-head sm-txt-a">Name</div>
        <div className={`choose-box ${smallMedia ? "choose-box-2" : ""}`}>
          <div className={` ${smallMedia ? "nameLeft-2" : "nameLeft-ac"}`}></div>
          <Select
            options={options}
            isSearchable={true}
            menuPlacement="auto"
            placeholder="Select Name..."
            styles={customStyles}
            className="choosen-prod"
            classNamePrefix="rs"
            value={
              selectedProduct
                ? { value: selectedProduct, label: selectedProduct }
                : null
            }
            onChange={(selected) => {
              const productName = selected?.value || "";

              setSelectedProduct(productName);

              const selectedIngredient = ingredients.find(
                ingredient => ingredient.name === productName
              );

              if (selectedIngredient) {
                setGetCost(selectedIngredient.cost_ml);
                setGetId(selectedIngredient.unique_id);
                setSelIngreType(selectedIngredient.type);
                setSnglAlco(
                  selectedIngredient.alcohol
                    ? selectedIngredient.alcohol
                    : 0
                );
              } else {
                setGetCost("");
                setGetId("");
                setSelIngreType("");
                setSnglAlco(0);
              }
            }}
          />
          <div className={` ${smallMedia ? "nameRight-2" : "nameRight-ac"}`}></div>
        </div>
      </div>
      <div className="product-q" >
        <div className='qty-head sm-txt-a'>Quantity(ml)</div>
        <div className={` p-q-cont ${smallMedia ? "p-q-cont-2" : ""}`}>
          <div className="p-q-cont-left"></div>
          <div className="quantity-area">
            <input
              type="number"
              value={productValue}
              onChange={(e) => setProductValue(e.target.value)}
              placeholder="Quantity"
              onWheel={(e) => e.target.blur()} 
              className={`${smallMedia ? "quantity-te-2" : "quantity-te"}`}
            />
          </div>
          <div className="p-q-cont-right"></div>
        </div>
      </div>
      <div className="product-a" >
        <div className='qty-head sub-cl2 sm-txt-a'>Action</div>
        <div className={`${smallMedia ? "p-a-btn-2" : "p-a-btn"}`} onClick={handleAddProduct}>
          <div className={`${smallMedia ? "shadeTriangle-quan-2" : "shadeTriangle-quan"}`}></div>
          <button className="add-btn">
            <span className="sub-symb">+</span>Add
          </button>
        </div>
      </div>
    </div> 
      {/* <p>Total Cost: {totalCost}</p> */}
    <div style={{display: smallMedia ? 'none' : 'block'}} className='allBtns'>
      <div className="btnClose"  >
      <div className='total-ml'>
      <label className='sm-txt-a'>Total(ml)</label>
      <div className="recal-btn-2">
      <div className="nameLeft-acca"></div>
      {/* <div className='shadeTriangle-recal-2 adjust-3'></div> */}
      <input className="recycle-btn no-spinners" type='number' 
        readonly 
        value={total} 
      /> 
      {/* {total}  */}
      <div className="nameRight-acca"></div>
      </div>
      </div>
      
        <div className="new-close-cont-2" onClick={handleClose}>
            <div className='shadeTriangle-recal-2'></div>
          <button  className="close-btn">
          <label className='close-icon-2'>
            <Clo_icon className='sp-icon'/>
          </label>
          Close
          </button>
        </div>
        <div className="new-close-cont-2" onClick={backTblNN}>
        <div className='shadeTriangle-recal-2'></div>
        <button  className="close-btn">
        <label className='close-icon-2'>
        <Sav_icon className='sp-icon'/>
          </label>
        Save</button>
        </div>
      </div>
      </div>
      </div>
      <div className={` ${smallMedia ? "only-table-2" : "only-table"}`}>
      {/* <h2>Product Table</h2> */}
      <div className="product-t">
      <table className='product-t-tbl'>
        <thead style={{display: showDrop ? 'none' : ''}}>
          <tr>
            <th>Name</th>
            <th>Quantity</th>
            <th>Disp at</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody className="custombody">
          {products.map((product, index)=>(
            <tr key={index} className="data-loop">
              
              <td className='for-re'>
                <div className={`t-data c-name ${smallMedia ? "t-name-2" : "t-name"}`} >
                  <div  className={` p-table-name ${smallMedia ? "p-table-name-2" : ""}`}>
                    <div className={` ${smallMedia ? "nameLeft-2" : "nameLeft-ca"}`}></div>
                    <div className='dy-name'>
                      {product.name}
                    </div>
                    <div className={` ${smallMedia ? "nameRight-2" : "nameRight-ca"}`}></div>
                  </div>
                </div>
              </td>

              <td  className='for-re'>
                <div  className={`t-data ${smallMedia ? "t-quantity-2" : "t-quantity"}`}> 
                  <div className={`${smallMedia ? "shadeTriangle-quan-2" : "shadeTriangle-quan"}`} ></div> 
                  <div className={`p-table-quantity ${smallMedia ? "p-table-quantity-2" : ""}`}>
                    {product.value ? `${Math.floor(product.value)}` : ''}
                  </div>
                </div>
              </td>

              <td className='for-re'>
                
                <div className={`t-data ${smallMedia ? "t-quantity-2" : "t-quantity"}`} >
                  <div className={`${smallMedia ? "shadeTriangle-quan-2" : "shadeTriangle-quan"}`} ></div>
                    <div className={`p-table-quantity ${smallMedia ? "p-table-quantity-2" : ""}`}>
                    <select 
                    style={{background: 'transparent', textAlign: 'center', border: 'none', width: '100%'}}
                  
                      value={product.proStep || ""}
                      onChange={(e) => handleStepChange(index, e.target.value)}
                      className={`p-table-quantity p-btn ${smallMedia ? "p-table-quantity-2" : ""}`}
                    >
                      <option style={{background: '#EF7C32', color: 'white'}} value="">Select</option>
                      {[1, 2, 3, 4, 5].map((step) => (
                        <option style={{background: '#EF7C32', color: 'white'}} key={step} value={step}>
                          {step}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
            </td>
              
              
              <td className='for-re'>
                <div className={`t-data ${smallMedia ? "t-action-2" : "t-action"}`}
                 onClick={() => handleDeleteProduct(index)}>
                  <div className={`${smallMedia ? "shadeTriangle-quan-2" : "shadeTriangle-quan"}`}></div>
                  <div className="p-t-a-btn">
                  <button className="p-btn">
                    <span className='span-del'>Del</span>
                  </button>
                  </div> 
                </div>
              </td>
              
            </tr>
          ))}
        </tbody>
      </table>
      </div>
      <div style={{display: smallMedia ? 'block' : 'none'}}>
      <div className={` ${smallMedia ? "btnClose-2" : "btnClose"}`} >
      <div className="recal-btn">
      <div className="recal-Left"></div>
      {/* <div className='shadeTriangle-recal'></div> */}
      <button className="recycle-btn"> {total} </button>
      <div className="recal-Right"></div>
      </div>
        <div className="new-close-cont" onClick={handleClose}>
            <div className='shadeTriangle-recal'></div>
          <button  className="close-btn">
          <img src={cancelIcon} alt="icon" className="close-icon" />
          Close
          </button>
        </div>
        <div className="new-close-cont" onClick={backTblNN}>
        <div className='shadeTriangle-recal'></div>
        <button  className="close-btn">
        <img src={saveIcon} alt="icon" className="close-icon" />
        Save</button>
        </div>
      </div>
      </div>
      <div className='prod-tbl-btm'>
          <div>Cost: <span>{grandTotal.toFixed(2)}</span></div>
          <div>
            Alcohol: <span>{total > 0 ? ((Number(ttlalco) / Number(total)) * 100).toFixed(2) : "0.00"}%</span>
          </div>
        </div>
      </div>
      </div>
    </div>
    <div className="recipe-right" style={{display: smallMedia ? 'none' : 'block'}}></div>
    </div>
    </>
  );
});

export default RecipesTable;
